<script setup>
import { ref, reactive, onBeforeMount, nextTick } from "vue";
import YTCard from "@/components/YTCard/newIndex.vue";
import YTAddress from "@/components/YTAddress/newIndex.vue";
import YTCheckTag from "@/components/YTCheckTag/replaceMode.vue";
import YTEditor from "@/components/YTEditor/index.vue";
import BoxUpload from "@/components/YTBoxUpload/newIndex.vue";
import { getRoute } from "@/hooks/getRoute.js";
import {
  detailClubActivityNew,
  editClubActivity,
  listClubCategory,
} from "@/api/club/club.js";
import moment from "moment/moment.js";
import router from "@/router/index.js";
const { route } = getRoute();
import YTRadio from "@/components/YTRadio/index.vue";
import YTAnchor from "@/components/YTAnchor/index.vue";
import YTTagSelect from "@/components/YTTagSelect/index.vue";
import {debounceFn} from "@/hooks/debounce.js";
import {tagGroupsListByUsageScenario} from "@/api/tagGroup/tagGroup.js";
import {formatTags} from "@/hooks/tag.js";
import YTGender from "@/components/YTGender/index.vue";
import YTTag from "@/components/YTTag/index.vue";
import {
  getStoreMemberListWithTag,
  getStoreMemberTotal,
  listStoreMemberTagChecked
} from "@/api/storeMember/storeMember.js";
import {disabledEndDate} from "@/hooks/dateUtils.js";
import YTI18NTabs from "@/components/YTIN18Tabs/index.vue";
import YTInputDisabledCover from "@/components/YTInputDisabledCover/index.vue"

/*初次加载*/
onBeforeMount(async () => {
  await handleGetActivityTagsList('init');
  await handleGetStoreGroups();
  if (route.query.goodsId) {
    isEdit.value = true;
    route.meta.bread[0].title = "活动资料更新";
    route.meta.title = "活动资料更新";
    route.meta.name = "活动资料更新";
    await getDetail(route.query.goodsId);
  } else {
    route.meta.bread[0].title = "发布新活动";
    route.meta.title = "发布新活动";
    route.meta.name = "发布新活动";
  }
});

// 是否为修改模式
const isEdit = ref(false);
// 获取活动详情信息
const getDetail = async (goodsId) => {
  try {
    loading.value = true;
    const res = await detailClubActivityNew(goodsId);
    ruleForm.images = res.images;
    boxUploadRef.value.handleReview(ruleForm.images);
    ruleForm.discoverCoverImage = res.discoverCoverImage;
    if (ruleForm.discoverCoverImage) boxUploadDiscoverCoverRef.value.handleReview([ruleForm.discoverCoverImage]);
    ruleForm.goodsId = res.goodsId;
    ruleForm.goodsName = res.goodsName;
    ruleForm.goodsNameEn = res.goodsNameEn;
    ruleForm.addressCode = [
      res.activityInfo.provinceCode,
      res.activityInfo.cityCode,
    ];
    if (res.activityInfo.districtCode)
      ruleForm.addressCode.push(res.activityInfo.districtCode);
    ruleForm.activityInfo.provinceCode = res.activityInfo.provinceCode;
    ruleForm.activityInfo.cityCode = res.activityInfo.cityCode;
    ruleForm.activityInfo.districtCode = res.activityInfo.districtCode;
    ruleForm.addressDetail = res.activityInfo.addressDetail;
    ruleForm.addressDetailEn = res.activityInfo.addressDetailEn;
    ruleForm.storeGroup = res.storeGroup;
    ruleForm.tagList = res.tagList;
    nextTick(() => {
      // 处理活动分组反显
      YTCheckTagRef.value.handleReview([ruleForm.storeGroup]);
      // 处理活动标签反显
      YTTagSelectRef.value.handleYTCheckTagMultipleReview(ruleForm.tagList)
    });
    ruleForm.activityInfo.cyclingDistance = res.activityInfo.cyclingDistance
    ruleForm.activityInfo.cyclingSpeed = res.activityInfo.cyclingSpeed
    ruleForm.description = res.description;
    ruleForm.descriptionEn = res.descriptionEn;
    ruleForm.startTime = res.activityInfo.startTime;
    ruleForm.endTime = res.activityInfo.endTime;
    ruleForm.applyStartTime = res.activityInfo.applyStartTime;
    ruleForm.applyEndTime = res.activityInfo.applyEndTime;
    ruleForm.inventory = res.inventory
      ? res.inventory
      : (ruleForm.inventory.totalQty = 1);
    ruleForm.retailPrice = res.retailPrice;
    ruleForm.activityInfo.refundSupported = res.activityInfo.refundSupported;
    ruleForm.activityInfo.requireIdInfo =
      res.activityInfo.requireIdInfo || false;
    ruleForm.activityInfo.hasAlbum = res.activityInfo.hasAlbum
    ruleForm.activityInfo.visibilityType = res.activityInfo.visibilityType
    ruleForm.activityInfo.detailVisibilityType = res.activityInfo.detailVisibilityType
    ruleForm.activityInfo.visibilityTagValue = res.activityInfo.visibilityTagValue
    ruleForm.activityInfo.activityType = res.activityInfo.activityType
    ruleForm.activityInfo.isNationwide = res.activityInfo.isNationwide
    ruleForm.activityInfo.mediaPlatformRequired =  res.activityInfo.mediaPlatformRequired
    ruleForm.activityInfo.shippingInfoRequired =  res.activityInfo.shippingInfoRequired
    ruleForm.activityInfo.activityDivisions =  res.activityInfo.activityDivisions
    ruleForm.activityInfo.activityDivisions.map(i => {
      console.log("run in map i")
      activityDivisionNameTab.value.push('zh')
      activityDescriptionTab.value.push('zh')
    })
    // 更改校验规则
    if (ruleForm.activityInfo.activityType === "OFFLINE") {
      rules.value = rulesTwo
    } else {
      rules.value = rulesOne
    }
    console.log("res", res);
    loading.value = false;
    nextTick(() => {
      // 处理发布按钮状态
      handleSubmitDisabled();
    });
  } catch (e) {
    console.log(e);
    loading.value = false;
  }
};

/*表单相关功能*/
// 表单加载状态
const loading = ref(false);
// 表单锚点
const ruleFormRef = ref();
// 发布活动表单
const ruleForm = reactive({
  goodsId: null,
  bizType: 2,
  goodsName: null,
  goodsNameEn: "Coming Soon ...",
  addressCode: null,
  addressDetail: null,
  addressDetailEn: "Coming Soon ...",
  storeGroup: {
    storeGroupId: null,
  },
  tagList: [],
  description: null,
  descriptionEn: "Coming Soon ...",
  descriptionImages: [],
  descriptionEnImages: [],
  startTime: null,
  endTime: null,
  applyStartTime: null,
  applyEndTime: null,
  inventory: {
    totalQty: 0,
  },
  retailPrice: 0,
  discoverCoverImage: [],
  images: [],
  activityInfo: {
    activityType: "OFFLINE",
    isNationwide: true,
    provinceCode: null,
    cityCode: null,
    districtCode: null,
    addressDetail: null,
    addressDetailEn: null,
    applyStartTime: null,
    applyEndTime: null,
    startTime: null,
    endTime: null,
    requireIdInfo: false,
    hasAlbum: false,
    cyclingDistance: null,
    cyclingSpeed: null,
    mediaPlatformRequired: "NOT_FILLED", // REQUIRED必填 OPTIONAL非必填 NOT_FILLED不填
    shippingInfoRequired: "NOT_FILLED", // REQUIRED必填 OPTIONAL非必填 NOT_FILLED不填
    visibilityType: null,
    detailVisibilityType: null,
    visibilityTagValue: [],
    refundSupported: null,
    activityDivisions: []
  },
});
// 活动名称校验规则
const checkGoodsName = (rule, value, callback) => {
  handleSubmitDisabled();
  if (!value) {
    return callback(new Error("请输入活动名称（中文）"));
  }
  if (!ruleForm.goodsNameEn) {
    return callback(new Error("请输入活动名称（English）"));
  }
  return callback();
};
// 活动类型校验
const checkActivityType = (rule, value, callback) => {
  handleSubmitDisabled();
  if (!ruleForm.activityInfo.activityType) {
    return callback(new Error("请选择活动类型"));
  }
  return callback();
}
// 活动地点校验规则
const checkAddress = (rule, value, callback) => {
  handleSubmitDisabled();
  if (ruleForm.activityInfo.activityType === "OFFLINE") {
    if (!ruleForm.addressCode) return callback(new Error("请选择活动地点省/市/区"));
    if (!ruleForm.addressDetail) return callback(new Error("请填写具体街、地点（中文）"));
    if (!ruleForm.addressDetailEn) return callback(new Error("请填写具体街、地点（English）"));
  } else {
    if (!ruleForm.activityInfo.isNationwide && !ruleForm.addressCode) return callback(new Error("请选择具体省市"));
  }

  return callback();
};
// 活动分组校验规则
const checkStoreGroup = (rule, value, callback) => {
  handleSubmitDisabled();
  if (!ruleForm.storeGroup) {
    return callback(new Error("请选择一个活动分组"));
  }
  return callback();
};
// 活动标签校验规则
const checkTagList = (rule, value, callback) => {
  handleSubmitDisabled();
  // 活动类型“线上”标签不必填，“线下”标签必填
  if (ruleForm.activityInfo.activityType === "OFFLINE" && ruleForm.tagList.length === 0) return  callback(new Error("请选择一个活动标签"));
  if (ruleForm.tagList.length > 2) {
    return callback(new Error("可选1-2个标签"));
  }
  return callback()
}
// 活动介绍校验规则
const checkDescription = (rule, value, callback) => {
  handleSubmitDisabled();
  console.log("YTEditorRef.value.isEmpty()", YTEditorRef.value.isEmpty())
  if (YTEditorRef.value.isEmpty()) {
    return callback(new Error("请输入活动相关的介绍描述（中文）"));
  }
  if (YTEditorEnRef.value.isEmpty()) {
    return callback(new Error("请输入活动相关的介绍描述（English）"));
  }
  return callback();
};
// 活动时间校验规则
const checkActivityTime = (rule, value, callback) => {
  handleSubmitDisabled();
  if (ruleForm.startTime || ruleForm.endTime) {
    if (!ruleForm.startTime) {
      return callback(new Error(`请选择活动开始时间`));
    } else if (!ruleForm.endTime) {
      return callback(new Error(`请选择活动结束时间`));
    }
    if (moment(ruleForm.startTime).isAfter(moment(ruleForm.endTime))) {
      return callback(new Error("活动结束时间不可小于活动开始时间"));
    }
    if (moment(ruleForm.applyStartTime).isAfter(moment(ruleForm.endTime))) {
      // 报名结束时间必须小于比赛开始时间
      return callback(
        new Error("活动开始时间必须在报名结束时间之后，请重新选择")
      );
    }
  } else {
    return callback(new Error(`请选择活动时间`));
  }
  return callback();
};

// 报名时间校验规则
const checkApplyTime = (rule, value, callback) => {
  handleSubmitDisabled();
  if (ruleForm.applyStartTime || ruleForm.applyEndTime) {
    if (!ruleForm.applyStartTime) {
      return callback(new Error("请选择报名开始时间"));
    } else if (!ruleForm.applyEndTime) {
      return callback(new Error("请选择报名结束时间"));
    }
    if (
      moment(ruleForm.applyStartTime).isAfter(moment(ruleForm.applyEndTime))
    ) {
      return callback(new Error("报名结束时间不可小于报名开始时间"));
    }
    if (moment(ruleForm.applyEndTime).isAfter(moment(ruleForm.endTime))) {
      // 报名结束时间必须小于比赛结束时间
      return callback(
        new Error("活动报名结束时间必须在活动结束时间之前，请重新选择")
      );
    }
  } else {
    return callback(new Error("请选择报名时间"));
  }
  return callback();
};
// 活动封面图校验规则
const checkImagesList = (rule, value, callback) => {
  handleSubmitDisabled();
  const listLength = boxUploadRef.value.fileList.length;
  if (listLength < 1) {
    return callback(new Error("请上传一张活动封面图"));
  }
  return callback();
};
// 人数上限校验规则
const checkInventory = (rule, value, callback) => {
  handleSubmitDisabled();
  if (ruleForm.activityInfo.activityDivisions.length > 0) {
    console.log("组别长度大于0，不校验外部人数上限")
  } else {
    if (ruleForm.inventory.totalQty === 0) return callback(new Error("人数上限必须大于0"));
  }
  return callback();
};
// 报名范围活动校验规则
const checkVisibilityType = (rule, value, callback) => {
  handleSubmitDisabled();
  if (!ruleForm.activityInfo.visibilityType) return callback(new Error("请选择报名范围"))
  return callback();
};
// 活动费用校验规则
const checkRetailPrice = (rule, value, callback) => {
  handleSubmitDisabled();
  if (value < 0) {
    return callback(new Error("活动费用不能小于0"));
  }
  return callback();
};
// 活动退费规则校验
const checkRefundSupported = (rule, value, callback) => {
  handleSubmitDisabled();
  if (ruleForm.activityInfo.refundSupported === null) {
    return callback(new Error("请选择退费规则"));
  }
  return callback();
};
// 活动分组规则校验
const checkActivityDivisions = (rule, value, callback) => {
  handleSubmitDisabled();
  if (ruleForm.activityInfo.activityDivisions.length <= 0) return callback();
  for(let i = 0; i < ruleForm.activityInfo.activityDivisions.length; i++) {
    if (!ruleForm.activityInfo.activityDivisions[i].divisionName) {
      return callback(new Error(`组别${handleTransformNumber(i + 1)}的组别名称（中文）不能为空`));
    }
    if (!ruleForm.activityInfo.activityDivisions[i].divisionNameEn) {
      return callback(new Error(`组别${handleTransformNumber(i + 1)}的组别名称（English）不能为空`));
    }
    if (ruleForm.activityInfo.activityDivisions[i].entryFee === '' || ruleForm.activityInfo.activityDivisions[i].entryFee === null) {
      return callback(new Error(`组别${handleTransformNumber(i + 1)}的报名费必填`));
    }
    if (ruleForm.activityInfo.activityDivisions[i].vipEntryFee === '' || ruleForm.activityInfo.activityDivisions[i].vipEntryFee === null) {
      return callback(new Error(`组别${handleTransformNumber(i + 1)}的VIP报名费必填`));
    }
    if (ruleForm.activityInfo.activityDivisions[i].quotaLimit === '' || ruleForm.activityInfo.activityDivisions[i].quotaLimit === null) {
      return callback(new Error(`组别${handleTransformNumber(i + 1)}的人数上限必填`));
    }
  }
  return callback();
}
// 活动类型“线上”校验规则
const rulesOne = {
  goodsName: [{ required: true, validator: checkGoodsName, trigger: "blur" }],
  activityType: [
    { required: true, validator: checkActivityType, trigger: "blur" }
  ],
  addressCode: [
    { required: true, validator: checkAddress, trigger: ["change", "blur"] },
  ],
  storeGroup: [
    { required: true, validator: checkStoreGroup, trigger: "change" },
  ],
  tagList: [
    { validator: checkTagList, trigger: "change" }
  ],
  activityDivisions: [
    { validator: checkActivityDivisions, trigger: ["change", "blur"] }
  ],
  description: [
    { required: true, validator: checkDescription, trigger: "blur" },
  ],
  activityTime: [
    {
      required: true,
      validator: checkActivityTime,
      trigger: ["change", "blur"],
    },
  ],
  applyTime: [
    { required: true, validator: checkApplyTime, trigger: ["change", "blur"] },
  ],
  inventory: [{ required: true, validator: checkInventory, trigger: "blur" }],
  visibilityType: [
    { required: true, validator: checkVisibilityType, trigger: "blur" }
  ],
  retailPrice: [
    { required: true, validator: checkRetailPrice, trigger: "blur" },
  ],
  refundSupported: [
    { required: true, validator: checkRefundSupported, trigger: "blur" }
  ],
  images: [{ validator: checkImagesList }],
}
// 活动类型“线下”校验规则
const rulesTwo = {
  goodsName: [{ required: true, validator: checkGoodsName, trigger: "blur" }],
  activityType: [
    { required: true, validator: checkActivityType, trigger: "blur" }
  ],
  addressCode: [
    { required: true, validator: checkAddress, trigger: ["change", "blur"] },
  ],
  storeGroup: [
    { required: true, validator: checkStoreGroup, trigger: "change" },
  ],
  tagList: [
    { required: true, validator: checkTagList, trigger: "change" }
  ],
  activityDivisions: [
    { validator: checkActivityDivisions, trigger: ["change", "blur"] }
  ],
  description: [
    { required: true, validator: checkDescription, trigger: "blur" },
  ],
  activityTime: [
    {
      required: true,
      validator: checkActivityTime,
      trigger: ["change", "blur"],
    },
  ],
  applyTime: [
    { required: true, validator: checkApplyTime, trigger: ["change", "blur"] },
  ],
  inventory: [{ required: true, validator: checkInventory, trigger: "blur" }],
  visibilityType: [
    { required: true, validator: checkVisibilityType, trigger: "blur" }
  ],
  retailPrice: [
    { required: true, validator: checkRetailPrice, trigger: "blur" },
  ],
  refundSupported: [
    { required: true, validator: checkRefundSupported, trigger: "blur" }
  ],
  images: [{ validator: checkImagesList }],
}
// 表单校验规则
const rules = ref(rulesTwo)
// 处理选择所属区域
const handleSelectAddress = (data) => {
  console.log("data:", data);
  ruleForm.addressCode = data.value;
  ruleForm.activityInfo.provinceCode = data.value[0];
  ruleForm.activityInfo.cityCode = data.value[1];
  ruleForm.activityInfo.districtCode =
    data.value.length === 3 ? data.value[2] : null;
  ruleFormRef.value.validateField("addressCode");
};
// 活动分组选项
const storeGroupsOption = ref([]);
// 活动分组锚点
const YTCheckTagRef = ref();
// 处理获取活动分组
const handleGetStoreGroups = async () => {
  try {
    loading.value = true;
    const res = await listClubCategory({ page: 1, pageSize: 100 });
    storeGroupsOption.value = res.list;
    loading.value = false;
  } catch (e) {
    loading.value = false;
  }
};
// 处理活动分组选中改变
const handleStoreGroupsChange = (checkedOption) => {
  let temp = {
    storeGroupId: null,
  };
  checkedOption.map((i) => {
    if (i.checked) {
      temp.storeGroupId = i.storeGroupId;
    }
  });
  ruleForm.storeGroup = temp.storeGroupId === null ? null : temp;
  ruleFormRef.value.validateField("storeGroup");
};

// 活动标签列表（现在“活动”标签上限10个）
const tagList = ref([])
// 获取活动标签列表
const handleGetActivityTagsList = async (type = 'init') =>  {
  try {
    loading.value = true
    const res = await tagGroupsListByUsageScenario({usageScenario: "ACTIVITY"})
    console.log("res", res)
    if (type === 'init') {
      tagList.value = res
    } else {
      res.map(item => {
        tagList.value.push(item)
      })
    }
    loading.value = false
  } catch (e) {
    console.log(e)
    loading.value = false
  }
}
// 会员标签列表
const memberTagList = ref([])
// 获取会员标签列表
const handleGetMemberTagsList = async (type = 'init') =>  {
  try {
    dialogLoading.value = true
    const res = await tagGroupsListByUsageScenario({usageScenario: "MEMBER"})
    console.log("res", res)
    if (type === 'init') {
      memberTagList.value = res
    } else {
      res.map(item => {
        memberTagList.value.push(item)
      })
    }
    dialogLoading.value = false
  } catch (e) {
    console.log(e)
    dialogLoading.value = false
  }
}

// 活动开始时间变化时重置结束时间
const handleStartTimeChange = (val, endTime) => {
  if (endTime && new Date(endTime) < new Date(val)) {
    ruleForm.endTime = null; // 如果结束时间早于新开始时间，清空
  }
};
// 禁用报名开始时间晚于活动时间的日期
const disabledApplyStartTime = (time, startTime) => {
  if (!startTime) return false; // 未选择开始时间时不限制
  // 比较日期部分，忽略时间
  const startDate = new Date(startTime);
  startDate.setHours(0, 0, 0, 0); // 归零时间部分

  const selectedDate = new Date(time);
  selectedDate.setHours(0, 0, 0, 0); // 归零时间部分

  // 禁用晚于活动时间的日期
  return selectedDate.getTime() > startDate.getTime();
};
// 富文本编辑器锚点
const YTEditorRef = ref();
// 富文本编辑器（English）锚点
const YTEditorEnRef = ref();
// 处理商品描述（中文）富文本赋值给表单
const handleRich2Form = async () => {
  console.log("赋值结果", YTEditorRef.value.getTxtTooLongState());
  if (YTEditorRef.value.getTxtTooLongState()) {
    ElMessage.error("商品描述（中文）内容过长，描述内容请按规定照字数编写。");
    return false;
  }
  ruleForm.description = YTEditorRef.value.getTxt();
  return true;
};
// 处理商品描述（English）富文本赋值给表单
const handleRich2FormEn = async () => {
  console.log("赋值结果", YTEditorEnRef.value.getTxtTooLongState());
  if (YTEditorEnRef.value.getTxtTooLongState()) {
    ElMessage.error(
      "商品描述（English）内容过长，描述内容请按规定照字数编写。"
    );
    return false;
  }
  ruleForm.descriptionEn = YTEditorEnRef.value.getTxt();
  return true;
};
// 活动封面图二上传锚点
const boxUploadRef = ref();
// 处理图片二上传成功
const handlePicSuccess = (url) => {
  ruleForm.images = [];
  ruleForm.images = url;
  ruleFormRef.value.validateField("images");
  handleSubmitDisabled();
  loading.value = false;
};
// 处理图片二列表改变
const handleImageRemove = (url) => {
  ruleForm.images = url;
  ruleFormRef.value.validateField("images");
};
// 活动封面图一上传锚点
const boxUploadDiscoverCoverRef = ref();
// 处理图片一上传成功
const handleDiscoverCoverPicSuccess = (url) => {
  ruleForm.discoverCoverImage = [];
  ruleForm.discoverCoverImage = url[0];
  ruleFormRef.value.validateField("discoverCoverImage");
  handleSubmitDisabled();
  loading.value = false;
};
// 处理图片一列表改变
const handleDiscoverCoverImageRemove = (url) => {
  ruleForm.discoverCoverImage = url;
  ruleFormRef.value.validateField("discoverCoverImage");
};
// 处理表单提交
const handleSubmit = async () => {
  if(ruleForm.activityInfo.hasAlbum){
    ruleForm.activityInfo.isSelfOss = true
  }
  await ruleFormRef.value.validate(async (valid) => {
    if (valid) {
      try {
        loading.value = true;
        // 处理活动地点
        ruleForm.activityInfo.addressDetail = ruleForm.addressDetail;
        ruleForm.activityInfo.addressDetailEn = ruleForm.addressDetailEn;
        // 处理富文本内容
        const res = await handleRich2Form();
        if (!res) throw new Errow("商品描述（中文）富文本描述过长");
        const res2 = await handleRich2FormEn();
        if (!res2) throw new Errow("商品描述（English）富文本描述过长");
        // 处理活动描述中富文本的图片地址
        ruleForm.descriptionImages = YTEditorRef.value.getImagesUrlArr();
        ruleForm.descriptionEnImages = YTEditorEnRef.value.getImagesUrlArr();
        // 处理活动时间
        ruleForm.activityInfo.startTime = ruleForm.startTime;
        ruleForm.activityInfo.endTime = ruleForm.endTime;
        // 处理报名时间
        ruleForm.activityInfo.applyStartTime = ruleForm.applyStartTime;
        ruleForm.activityInfo.applyEndTime = ruleForm.applyEndTime;
        // 处理线上活动为“全国”时地址选择器的缓存
        if (ruleForm.activityInfo.activityType === "ONLINE") {
          ruleForm.addressDetail = null
          if (ruleForm.activityInfo.isNationwide) {
            // 选择“全国”清空已选的省市区信息
            ruleForm.addressCode = null
            ruleForm.activityInfo.provinceCode = null
            ruleForm.activityInfo.cityCode = null
            ruleForm.activityInfo.districtCode = null
          } else {
            ruleForm.activityInfo.districtCode = null
          }
        }
        // 处理活动分组信息
        if (ruleForm.activityInfo.activityDivisions.length > 0) {
          ruleForm.inventory = null
          ruleForm.activityInfo.activityDivisions.map(i => {
            i.entryFee = i.entryFee ?? 0
            i.vipEntryFee = i.vipEntryFee ?? 0
            i.quotaLimit = i.quotaLimit ?? 1
            i.distance = i.distance ?? 0
          })
        }
        // 发起接口请求
        await editClubActivity(ruleForm);
        ElMessage.success(isEdit.value ? "修改成功" : "发布成功");
        router.push("/store/listActivity");
        loading.value = true;
      } catch (e) {
        console.log(e);
        loading.value = false;
      }
    } else {
      ElMessage.error("请根据提示修改表单信息");
      loading.value = false;
    }
  });
};
// 处理组别信息校验状态
const handleActivityDivisionsCheck = () => {
  let res = true
  if (ruleForm.activityInfo.activityDivisions.length <= 0) return res
  for(let i = 0; i < ruleForm.activityInfo.activityDivisions.length; i++) {
    if (!ruleForm.activityInfo.activityDivisions[i].divisionName) {
      res = false
      return
    }
    if (!ruleForm.activityInfo.activityDivisions[i].divisionNameEn) {
      res = false
      return
    }
    if (ruleForm.activityInfo.activityDivisions[i].entryFee === '' || ruleForm.activityInfo.activityDivisions[i].entryFee === null) {
      res = false
      return
    }
    if (ruleForm.activityInfo.activityDivisions[i].vipEntryFee === '' || ruleForm.activityInfo.activityDivisions[i].vipEntryFee === null) {
      res = false
      return
    }
    if (ruleForm.activityInfo.activityDivisions[i].quotaLimit === '' || ruleForm.activityInfo.activityDivisions[i].quotaLimit === null) {
      res = false
      return
    }
  }
  return res
}
// 处理按钮是否禁用
const handleSubmitDisabled = () => {
  // 基础信息填写状态（为空是true）
  const basicEmpty = (ruleForm.goodsName === null || ruleForm.goodsName === "") ||
      (ruleForm.goodsNameEn === null || ruleForm.goodsNameEn === "") ||
      ruleForm.activityInfo.activityType === null ||
      (ruleForm.activityInfo.activityType === "OFFLINE" && ruleForm.addressCode === null) ||
      (ruleForm.activityInfo.activityType === "ONLINE" && !ruleForm.activityInfo.isNationwide && ruleForm.addressCode === null) ||
      (ruleForm.activityInfo.activityType === "OFFLINE" && (ruleForm.addressDetail === null || ruleForm.addressDetail === "") && (ruleForm.addressDetailEn === null || ruleForm.addressDetailEn === "")) ||
      ruleForm.storeGroup === null ||
      ruleForm.storeGroup?.storeGroupId === null ||
      (ruleForm.activityInfo.activityType === "OFFLINE" && ruleForm.tagList.length === 0) ||
      !handleActivityDivisionsCheck() ||
      YTEditorRef.value.isEmpty() ||
      YTEditorEnRef.value.isEmpty() ||
      ruleForm.startTime === null ||
      ruleForm.endTime === null
  console.log("basicEmpty", basicEmpty)
  // 填写完成，基础信息步骤条填写状态改为true
  stepOptions.value[0].filled = !basicEmpty;
  // 报名信息填写状态（为空是true）
  const signupEmpty = ruleForm.applyStartTime === null ||
      ruleForm.applyEndTime === null ||
      (ruleForm.activityInfo.activityDivisions.length === 0 && ruleForm.inventory?.totalQty <= 0) ||
      ruleForm.activityInfo.visibilityType === null
  // 填写完成，报名信息步骤条填写状态改为true
  stepOptions.value[1].filled = !signupEmpty;
  // 相册、费用及退费规则填写状态
  const albumEmpty = ruleForm.retailPrice < 0 || ruleForm.activityInfo.refundSupported === null
  // 填写完成，相册及费用步骤条填写状态改为true
  stepOptions.value[2].filled = !albumEmpty && !basicEmpty && !signupEmpty;
  // 活动封面图填写状态
  const imagesEmpty = ruleForm.images.length <= 0 || ruleForm.discoverCoverImage.length <= 0
  // 填写完成，活动封面图步骤条填写状态改为true
  stepOptions.value[3].filled = !imagesEmpty
  submitDisabled.value = basicEmpty ||
    signupEmpty ||
    albumEmpty ||
    imagesEmpty
};
// 发布按钮禁用状态
const submitDisabled = ref(true);
// 处理报名范围改变
const handleVisibilityChange = (type) => {
  if (isEdit.value) return ElMessage.error("已发布的活动不允许修改报名范围")
  ruleForm.activityInfo.visibilityType = type
  ruleFormRef.value.validateField("visibilityType");
  // 类型为：邀请可报名。打开选择会员标签弹窗。
  if (type === "SPECIFIED_USER") {
    open.value = true
    handleGetMemberCount()
    handleGetMemberTagsList()
  } else {
    // 否则清空缓存的会员标签信息
    ruleForm.activityInfo.visibilityTagValue = []
    // 否则detailVisibilityType为'SPECIFIED_USER'，清空活动详情可见范围信息
    if (ruleForm.activityInfo.detailVisibilityType === 'SPECIFIED_USER') ruleForm.activityInfo.detailVisibilityType = null
  }
}
// 处理活动详情可见范围改变
const handleDetailVisibilityTypeChange = (type) => {
  if (isEdit.value) return ElMessage.error("已发布的活动不允许修改活动详情可见范围")
  ruleForm.activityInfo.detailVisibilityType = type
  ruleFormRef.value.validateField("detailVisibilityType");
}
// 处理退费规则改变
const handleRefundSupportedChange = (type) => {
  if (isEdit.value) return ElMessage.error("已发布的活动不允许修改退费规则")
  ruleForm.activityInfo.refundSupported = type
  handleSubmitDisabled();
}

// 展示不可修改报名范围的提示
const handleShowVisibilityError = () => {
  ElMessage.error('已发布的活动不允许修改报名范围')
}
// 处理邀请会员
const handleInviteMemberDialog = async () => {
  open.value = true
  let isReview = ruleForm.activityInfo.visibilityTagValue.length > 0
  console.log("ruleForm.activityInfo.visibilityTagValue", ruleForm.activityInfo.visibilityTagValue)
  await handleGetMemberTagsList()
  // 已选择了标签，做反显
  if (isReview) {
    let reviewList = []
    ruleForm.activityInfo.visibilityTagValue.map(i => {
      console.log("map i", i)
      console.log("map memberTagList.value", memberTagList.value)
      memberTagList.value.map(tagGroup => {
        const res = tagGroup.tagList.find(tag => tag.tagId === i)
        console.log("map res", res)
        if (res) reviewList.push({tagId: res.tagId, tagName: res.tagName})
      })
    })
    console.log("reviewList", reviewList)
    nextTick(() => {
      // 组件反显
      YTTagSelectDialogRef.value.handleYTCheckTagMultipleReview(reviewList)
    })
    // 输入框反显
    dialogTagList.value = reviewList
  }
  await handleGetMemberCount()
  if (isReview) await handleGetMemberInfoWithTag('init')
}

// 获取当前俱乐部会员总数
const clubMemberCount = ref(0)
const handleGetMemberCount = async () => {
  try {
    dialogLoading.value = true
    const res = await getStoreMemberTotal()
    console.log("res", res)
    clubMemberCount.value = parseInt(res)
    dialogLoading.value = false
  } catch (e) {
    console.log(e)
    dialogLoading.value = false
  }
}

// 处理活动类型改变
const handleActivityTypeChange = (type) => {
  ruleForm.activityInfo.activityType = type
  handleSubmitDisabled()
  if (ruleForm.activityInfo.activityType === "OFFLINE") {
    rules.value = rulesTwo
    // 选择线下，清空“新媒体平台信息”的选择信息
    ruleForm.activityInfo.mediaPlatformRequired = "NOT_FILLED"
  } else {
    rules.value = rulesOne
  }
  ruleFormRef.value.validateField("activityType")
}
// 处理活动类型为“线上”活动地点选项改变
const handleIsNationwideChange = (type) => {
  ruleForm.activityInfo.isNationwide = type
  ruleFormRef.value.validateField("addressCode")
  handleSubmitDisabled()
}

// 处理活动相关介绍改变
const handleYTEditorChange = () => {
  ruleFormRef.value.validateField("description")
  handleSubmitDisabled()
}

/*步骤条相关*/
// 步骤条配置
const stepOptions = ref([
  {
    href: "#basic",
    title: "填写基础信息",
    filled: false
  },
  {
    href: "#signup",
    title: "填写报名信息",
    filled: false
  },
  {
    href: "#album",
    title: "相册及费用",
    filled: false
  },
  {
    href: "#publish",
    title: "活动封面图",
    filled: false
  }
])

/*活动标签组件相关*/
// 标签选择器组件锚点
const YTTagSelectRef = ref()
// 活动标签改变
const handleActivityTagChange = (list) => {
  console.log("handleActivityTagChange", list)
  ruleForm.tagList = list.flatMap(i => i.tagList.length > 0 ? i.tagList.filter(tag => tag.checked).map(item => ({ tagId: item.tagId, tagName: item.tagName })) : [])
  ruleFormRef.value.validateField("tagList");
}
// 处理点击活动标签输入框删除按钮
const handleTagListRemoveTag = (tagId) => {
  const resIndex = ruleForm.tagList.findIndex(i => i.tagId === tagId)
  ruleForm.tagList.splice(resIndex, 1)
  YTTagSelectRef.value.handleYTCheckTagMultipleRemove(tagId)
}

/*仅邀请会员可报名。弹窗邀请相关*/
// 弹窗状态
const open = ref(false)
// 弹窗加载状态
const dialogLoading = ref(false)
// 处理邀请弹窗关闭
const handleDialogClose = () => {
  open.value = false
  dialogTagList.value = []
  dialogMemberTotal.value = 0
  clubMemberCount.value = 0
  dialogMemberList.value = []
  dialogPage.value = 1
}
// 弹窗的标签选择器锚点
const YTTagSelectDialogRef = ref()
// 弹窗邀请已选择的标签列表
const dialogTagList = ref([])
// 弹窗邀请标签改变
const handleDialogTagChange = async (list) => {
  dialogTagList.value = list.flatMap(i => i.tagList.length > 0 ? i.tagList.filter(tag => tag.checked).map(item => ({ tagId: item.tagId, tagName: item.tagName })) : [])
  await handleGetMemberInfoWithTag("init")
}
// 处理弹窗点击删除标签
const handleRemoveDialogTag = (tagId) =>{
  const resIndex = dialogTagList.value.findIndex(i => i.tagId === tagId)
  dialogTagList.value.splice(resIndex, 1)
  YTTagSelectDialogRef.value.handleYTCheckTagMultipleRemove(tagId)
  handleGetMemberInfoWithTag()
}
// 查询出的会员信息
const dialogMemberList = ref([])
// 查询出的会员总条数
const dialogMemberTotal = ref(0)
// 当前页
const dialogPage = ref(1)
// 单页长度
const dialogPageSize = ref(10)
// 输入框的当前页数
const pageInput = ref('1');
// 处理弹窗翻页输入
const handleDialogPageInput = (event) => {
  // 实时过滤非数字
  const numbersOnly = event.target.value.replace(/[^\d]/g, '');
  pageInput.value = numbersOnly;
  dialogPage.value = parseInt(numbersOnly) || 1;
};
// 处理弹窗翻页当前页数改变
const handleDialogPageChange = () => {
  const maxPage = Math.ceil(dialogMemberTotal.value / dialogPageSize.value);
  let finalPage = parseInt(pageInput.value) || 1;
  // 边界检查
  if (finalPage > maxPage) finalPage = maxPage;
  if (finalPage < 1) finalPage = 1;
  // 同步更新两个值
  dialogPage.value = finalPage;
  pageInput.value = finalPage.toString();
}
// 处理弹窗翻页按钮
const handleDialogPageBtnChange = (type) => {
  const totalPage = Math.ceil(dialogMemberTotal.value / dialogPageSize.value)
  if (type === 'plus') {
    const resPage = dialogPage.value + 1
    console.log("resPage", resPage)
    console.log("totalPage", totalPage)
    console.log("resPage > totalPage", resPage > totalPage)
    if (resPage > totalPage) return
    dialogPage.value++
  } else {
    const resPage = dialogPage.value - 1
    if (resPage < 1) return
    dialogPage.value--
  }
  pageInput.value = dialogPage.value
  handleGetMemberInfoWithTag('turn')
}
// 根据标签获取会员信息
const handleGetMemberInfoWithTag = async (type) => {
  if (type === 'init') dialogPage.value = 1
  try {
    let page = {
      page: dialogPage.value,
      pageSize: dialogPageSize.value
    }
    let param = []
    dialogTagList.value.map(i => {
      param.push(i.tagId)
    })
    dialogLoading.value = true
    let res = null
    if (isEdit.value) {
      res = await listStoreMemberTagChecked(page, ruleForm.goodsId)
    } else {
      res = await getStoreMemberListWithTag(page, {tagIdList: param})
    }
    console.log("Res", res)
    dialogMemberList.value = res.list
    dialogMemberTotal.value = parseInt(res.total)
    dialogLoading.value = false
  } catch (e) {
    console.log(e)
    dialogLoading.value = false
  }
}
// 处理弹窗表格中标签名称展示内容为String
const handleShowTagList = (list) => {
  let temp = []
  try {
    list.map(i => temp.push(i.tagName))
  } catch (e) {
    console.log(e)
  }
  return temp.join("、")
}
// 处理弹窗选择的标签信息
const handleDialogSubmit = () => {
  let temp = []
  dialogTagList.value.map(i => temp.push(i.tagId))
  ruleForm.activityInfo.visibilityTagValue = temp
  handleDialogClose()
}

// 封面图实例弹窗打开状态
const openExamples = ref(false)
// 处理展示封面图示例
const handleShowExamples = () => {
  openExamples.value = true
}

// 处理收货信息选择
const handleChangeShippingInfoRequired = (type) => {
  if (ruleForm.activityInfo.shippingInfoRequired === type) {
    ruleForm.activityInfo.shippingInfoRequired = "NOT_FILLED"
  } else {
    ruleForm.activityInfo.shippingInfoRequired = type
  }
}

// 处理新媒体平台信息选择
const handleChangeMediaPlatformRequired = (type) => {
  if (ruleForm.activityInfo.mediaPlatformRequired === type) {
    ruleForm.activityInfo.mediaPlatformRequired = "NOT_FILLED"
  } else {
    ruleForm.activityInfo.mediaPlatformRequired = type
  }
}

/*活动分组相关*/
// 处理添加活动分组
const handleAddActivityDivisions = () => {
  if (ruleForm.activityInfo.activityDivisions.length >= 10) {
    ElMessage.error("最多可添加10个组别")
    return
  }
  activityDivisionNameTab.value.push('zh')
  activityDescriptionTab.value.push('zh')
  ruleForm.activityInfo.activityDivisions.push({
    divisionName: null,
    divisionNameEn: null,
    originalPrice: null,
    entryFee: null,
    vipEntryFee: null,
    quotaLimit: null,
    distance: null,
    elevationGain: null,
    description: null,
    descriptionEn: null
  })
}
// 处理分组数字转换
const handleTransformNumber = (num) => {
  let res = ""
  switch (num) {
    case 1:
      res = "一"
      break
    case 2:
      res = "二"
      break
    case 3:
      res = "三"
      break
    case 4:
      res = "四"
      break
    case 5:
      res = "五"
      break
    case 6:
      res = "六"
      break
    case 7:
      res = "七"
      break
    case 8:
      res = "八"
      break
    case 9:
      res = "九"
      break
    case 10:
      res = "十"
      break
    default:
      res = "未知"
      break
  }
  return res
}
// 处理活动组别删除
const handleRemoveActivityDivisions = (index) => {
  ruleForm.activityInfo.activityDivisions.splice(index, 1)
  activityDivisionNameTab.value.splice(index, 1)
  activityDescriptionTab.value.splice(index, 1)
  ruleFormRef.value.validateField("activityDivisions");
  handleSubmitDisabled()
}

/*中英文切换输入框相关Tab*/
// 活动名称tab
const goodsNameTab = ref("zh");
// 活动地点tab
const addressDetailTab = ref("zh")
// 活动介绍描述
const descriptionTab = ref("zh")
// 活动组别组别名称tab
const activityDivisionNameTab = ref([])
// 活动组别组别相关介绍描述tab
const activityDescriptionTab = ref([])
</script>

<template>
  <el-form
    ref="ruleFormRef"
    :model="ruleForm"
    :rules="rules"
    style="height: 100%"
  >
    <div
      class="new_container_box flex"
      style="height: 100%; min-width: 950px"
      v-loading="loading"
    >
      <div class="activity_upload_box">
        <YTCard :title="`活动封面图`" :isShowExamples="true" @click-title-after="handleShowExamples">
          <template #container>
            <div style="margin-top: 24px">
              <el-form-item prop="discoverCoverImage">
                <BoxUpload
                  :isReplaceMode="true"
                  :isRequired="true"
                  ref="boxUploadDiscoverCoverRef"
                  :ali-oss-path="'GOODS_DISCOVER_COVER_IMAGE'"
                  :width="280"
                  :height="280"
                  :limit="1"
                  :file-size="1"
                  :coverName="'封面一'"
                  @progress="loading = true"
                  @remove="handleDiscoverCoverImageRemove"
                  @success="handleDiscoverCoverPicSuccess"
                ></BoxUpload>
              </el-form-item>
              <el-form-item prop="images">
                <BoxUpload
                    :isReplaceMode="true"
                    :isRequired="true"
                    ref="boxUploadRef"
                    :ali-oss-path="'GOODS_IMG_PATH'"
                    :width="139"
                    :height="83"
                    :limit="1"
                    :file-size="1"
                    :coverName="'封面二'"
                    @progress="loading = true"
                    @remove="handleImageRemove"
                    @success="handlePicSuccess"
                ></BoxUpload>
              </el-form-item>
            </div>
          </template>
        </YTCard>
      </div>
      <div class="w-100">
        <div style="max-width: 1125px;">
          <YTAnchor container="#activityContainer" :links="stepOptions"></YTAnchor>
        </div>
        <div
          id="activityContainer"
          class="activity_form_box"
          style="padding: 0 8px 0 125px; box-sizing: border-box"
        >
          <div style="max-width: 1000px">
            <YTCard :title="`基础信息`" id="basic">
              <template #container>
                <el-form-item label="活动名称：" prop="goodsName">
                  <div class="flex_center flex_left w-100">
                    <el-input
                        v-model="ruleForm.goodsName"
                        v-show="goodsNameTab === 'zh'"
                        :class="
                      ruleForm.goodsName === null || ruleForm.goodsName === ''
                        ? 'input-null mg_r_2'
                        : 'input-filled mg_r_2'
                    "
                        style="height: 36px"
                        placeholder="活动名称"
                    ></el-input>
                    <el-input
                        v-model="ruleForm.goodsNameEn"
                        v-show="goodsNameTab === 'en'"
                        :class="
                      ruleForm.goodsNameEn === null || ruleForm.goodsNameEn === ''
                        ? 'input-null mg_r_2'
                        : 'input-filled mg_r_2'
                    "
                        style="height: 36px"
                        placeholder="activity name"
                    ></el-input>
                    <YTI18NTabs v-model="goodsNameTab"></YTI18NTabs>
                  </div>
                </el-form-item>
                <el-form-item label="活动类型：" prop="activityType">
                  <div class="flex_left mg_r_3 cursor-pointer" @click="handleActivityTypeChange('ONLINE')">
                    <div style="margin-right: 13px">
                      <YTRadio
                          :show="ruleForm.activityInfo.activityType === 'ONLINE'"
                      ></YTRadio>
                    </div>
                    <div style="font-size: 16px" class="tips">
                      线上
                    </div>
                  </div>
                  <div class="flex_left mg_r_3 cursor-pointer" @click="handleActivityTypeChange('OFFLINE')">
                    <div style="margin-right: 13px">
                      <YTRadio
                          :show="ruleForm.activityInfo.activityType === 'OFFLINE'"
                      ></YTRadio>
                    </div>
                    <div style="font-size: 16px" class="tips">
                      线下
                    </div>
                  </div>
                </el-form-item>
                <el-form-item label="活动地点：" prop="addressCode">
                  <div
                    class="flex_left w-100"
                    style="box-sizing: border-box; padding-right: 20px"
                  >
                    <div class="flex_left w-100" v-show="ruleForm.activityInfo.activityType === 'ONLINE'">
                      <div class="flex_left mg_r_3 cursor-pointer" @click="handleIsNationwideChange(true)">
                        <div style="margin-right: 13px">
                          <YTRadio
                              :show="ruleForm.activityInfo.isNationwide"
                          ></YTRadio>
                        </div>
                        <div style="font-size: 16px" class="tips">
                          全国
                        </div>
                      </div>
                      <div class="flex_left mg_r_3 cursor-pointer">
                        <div style="margin-right: 13px" @click="handleIsNationwideChange(false)">
                          <YTRadio
                              :show="!ruleForm.activityInfo.isNationwide"
                          ></YTRadio>
                        </div>
                        <div style="width: 210px">
                          <YTAddress
                              :disabled="ruleForm.activityInfo.isNationwide"
                              :onlySecond="true"
                              :placeholder="`请选择具体省市`"
                              class="mg_r_2"
                              :addressCode="ruleForm.addressCode"
                              @select="handleSelectAddress"
                          ></YTAddress>
                        </div>
                      </div>
                    </div>
                    <div class="flex_left w-100" v-show="ruleForm.activityInfo.activityType === 'OFFLINE'">
                      <div style="width: 210px">
                        <YTAddress
                            :placeholder="`省/市/区`"
                            class="mg_r_2"
                            :addressCode="ruleForm.addressCode"
                            @select="handleSelectAddress"
                        ></YTAddress>
                      </div>
                      <div class="flex_left" style="flex: 1">
                        <el-input
                            v-show="addressDetailTab === 'zh'"
                            v-model="ruleForm.addressDetail"
                            :class="
                          ruleForm.addressDetail === null ||
                          ruleForm.addressDetail === ''
                            ? 'input-null'
                            : 'input-filled'
                        "
                            style="
                          max-width: 780px;
                          height: 36px;
                          display: flex;
                          flex-wrap: nowrap;
                          align-items: center;
                          margin-right: 20px;
                        "
                            placeholder="请填写具体街、地点"
                        ></el-input>
                        <el-input
                            v-show="addressDetailTab === 'en'"
                            v-model="ruleForm.addressDetailEn"
                            :class="
                          ruleForm.addressDetailEn === null ||
                          ruleForm.addressDetailEn === ''
                            ? 'input-null'
                            : 'input-filled'
                        "
                            style="
                          max-width: 780px;
                          height: 36px;
                          display: flex;
                          flex-wrap: nowrap;
                          align-items: center;
                          margin-right: 20px;
                        "
                            placeholder="Please fill in the specific street and location"
                        ></el-input>
                        <YTI18NTabs v-model="addressDetailTab"></YTI18NTabs>
                      </div>
                    </div>
                  </div>
                </el-form-item>
                <el-form-item label="活动分组：" prop="storeGroup">
                  <YTCheckTag
                    ref="YTCheckTagRef"
                    :limit="1"
                    :options="storeGroupsOption"
                    @change="handleStoreGroupsChange"
                  ></YTCheckTag>
                </el-form-item>
                <el-form-item label="活动标签：" prop="tagList">
                  <YTTagSelect ref="YTTagSelectRef" :selectedCount="ruleForm.tagList.length" :width="416" :tagList="tagList" @tagChange="handleActivityTagChange">
                    <template #trigger="{ toggle, visible }">
                      <div @click="toggle">
                        <div :class="['yt_tag_select_box', ruleForm.tagList.length === 0
                            ? 'input-null'
                            : 'input-filled'
                        ]">
                          <div class="el-select__wrapper flex_left">
                            <div style="flex:1">
                              <div class="yt_tag_select_placeholder" v-if="ruleForm.tagList.length === 0">可选择1-2个标签</div>
                              <div v-else>
                                <span class="yt_tag_select_tag" v-for="(item, index) in ruleForm.tagList" :key="`tagListInput${index}`">
                                  {{item.tagName}}
                                  <img @click.stop="handleTagListRemoveTag(item.tagId)" style="width: 10px;height: 10px;margin-left: 5px;" src="https://yttec-bucket.oss-cn-guangzhou.aliyuncs.com/resources/newUi/activity/activity/tag_remove.svg"/>
                                </span>
                              </div>
                            </div>
                            <div class="yt_tag_select_suffix">
                              <img class="yt_tag_select_suffix_icon" src="@/assets/images/filter/select-arrowDown.svg" :class="{reverse: visible}"/>
                            </div>
                          </div>
                        </div>
                      </div>
                    </template>
                  </YTTagSelect>
                </el-form-item>
                <el-divider/>
                <div>
                  <el-form-item prop="activityDivisions">
                    <div class="flex_center flex_left" v-show="ruleForm.activityInfo.activityDivisions.length <= 0">
                      <div class="flex_left cursor-pointer" @click="handleAddActivityDivisions" >
                        <img
                            style="width: 25px; height: 25px; margin-right: 11px"
                            src="https://yttec-bucket.oss-cn-guangzhou.aliyuncs.com/resources/newUi/createClub/add_member.svg"
                        />
                        <div class="add_btn_txt mg_r_1">增加活动组别({{ruleForm.activityInfo.activityDivisions.length}}/10)</div>
                      </div>
                      <div class="add_btn_txt_tips">最多可添加10个组别</div>
                    </div>
                    <div v-for="(item, index) in ruleForm.activityInfo.activityDivisions" :key="`activityDivisions${index}`" :class="['groups_info', {mg_t_3: index !== 0}]" v-show="ruleForm.activityInfo.activityDivisions.length > 0">
                      <div class="flex_bt" style="margin-bottom: 22px;">
                        <div class="flex_center flex_left">
                          <div class="mg_r_3">组别{{handleTransformNumber(index + 1)}}：</div>
                          <img
                              @click="handleRemoveActivityDivisions(index)"
                              class="cursor-pointer"
                              style="width: 33px; height: 33px"
                              src="https://yttec-bucket.oss-cn-guangzhou.aliyuncs.com/resources/newUi/createClub/delete.svg"
                          />
                        </div>
                        <div class="flex_center flex_left" v-show="index + 1 === ruleForm.activityInfo.activityDivisions.length">
                          <div class="flex_left cursor-pointer" @click="handleAddActivityDivisions" >
                            <img
                                style="width: 25px; height: 25px; margin-right: 11px"
                                src="https://yttec-bucket.oss-cn-guangzhou.aliyuncs.com/resources/newUi/createClub/add_member.svg"
                            />
                            <div class="add_btn_txt mg_r_1">增加活动组别({{ruleForm.activityInfo.activityDivisions.length}}/10)</div>
                          </div>
                          <div class="add_btn_txt_tips">最多可添加10个组别</div>
                        </div>
                      </div>
                      <div class="flex_center flex_left mg_b_3">
                        <el-input maxlength="30" show-word-limit v-model="item.divisionName" v-show="activityDivisionNameTab[index] === 'zh'" class="groups_input" placeholder="组别名称" style="margin-right: 15px;width: 100%">
                          <template #prefix>
                            <div
                                style="
                              width: 38px;
                              box-sizing: border-box;
                              padding-right: 20px;
                            "
                            >
                              <span style="color: #DC4C2F">*</span>
                            </div>
                          </template>
                        </el-input>
                        <el-input maxlength="90" show-word-limit v-model="item.divisionNameEn" v-show="activityDivisionNameTab[index] === 'en'" class="groups_input" placeholder="division name" style="margin-right: 15px;width: 100%">
                          <template #prefix>
                            <div
                                style="
                              width: 38px;
                              box-sizing: border-box;
                              padding-right: 20px;
                            "
                            >
                              <span style="color: #DC4C2F">*</span>
                            </div>
                          </template>
                        </el-input>
                        <YTI18NTabs v-model="activityDivisionNameTab[index]"></YTI18NTabs>
                      </div>
                      <div class="flex_bt w-100 mg_b_3">
                        <el-input-number v-model="item.originalPrice" class="cycling_box" style="min-width: 220px;max-width: 258px;" :precision="2" :min="0" placeholder="报名费原价">
                          <template #prefix>
                            <div
                                style="
                              width: 38px;
                              box-sizing: border-box;
                              padding-right: 20px;
                            "
                            >
                              ￥
                            </div>
                          </template>
                        </el-input-number>
                        <el-input-number v-model="item.entryFee" class="cycling_box" style="min-width: 220px;max-width: 258px;" :precision="2" :min="0" placeholder="报名费">
                          <template #prefix>
                            <div
                                style="
                              width: 38px;
                              box-sizing: border-box;
                              padding-right: 20px;
                            "
                            >
                              <span style="color: #DC4C2F">*</span>
                              ￥
                            </div>
                          </template>
                        </el-input-number>
                        <el-input-number v-model="item.vipEntryFee" class="cycling_box" style="min-width: 220px;max-width: 258px;" :precision="2" :min="0" placeholder="VIP报名费">
                          <template #prefix>
                            <div
                                style="
                              width: 38px;
                              box-sizing: border-box;
                              padding-right: 20px;
                            "
                            >
                              <span style="color: #DC4C2F">*</span>
                              ￥
                            </div>
                          </template>
                        </el-input-number>
                      </div>
                      <div class="flex_bt w-100 groups_info_suffix mg_b_3">
                        <el-input-number v-model="item.quotaLimit" class="cycling_box" style="min-width: 220px;max-width: 258px;" :precision="0" :min="1" placeholder="人数上限">
                          <template #prefix>
                            <div
                                style="
                              width: 38px;
                              box-sizing: border-box;
                              padding-right: 20px;
                            "
                            >
                              <span style="color: #DC4C2F">*</span>
                            </div>
                          </template>
                          <template #suffix>
                            <div
                                style="
                              width: 38px;
                              box-sizing: border-box;
                              padding-right: 20px;
                            "
                            >
                              人
                            </div>
                          </template>
                        </el-input-number>
                        <el-input-number v-model="item.distance" class="cycling_box" style="min-width: 220px;max-width: 258px;" :precision="2" :min="0" placeholder="骑行距离">
                          <template #suffix>
                            <div
                                style="
                              width: 38px;
                              box-sizing: border-box;
                              padding-right: 20px;
                            "
                            >
                              km
                            </div>
                          </template>
                        </el-input-number>
                        <el-input-number v-model="item.elevationGain" class="cycling_box" style="min-width: 220px;max-width: 258px;" :precision="2" :min="0" placeholder="爬升">
                          <template #suffix>
                            <div
                                style="
                              width: 38px;
                              box-sizing: border-box;
                              padding-right: 20px;
                            "
                            >
                              m
                            </div>
                          </template>
                        </el-input-number>
                      </div>
                      <div class="flex">
                        <el-input maxlength="200" show-word-limit v-model="item.description" v-show="activityDescriptionTab[index] === 'zh'" class="groups_input" placeholder="请填写组别相关介绍描述" style="margin-right: 15px;width: 100%"></el-input>
                        <el-input maxlength="600" show-word-limit v-model="item.descriptionEn" v-show="activityDescriptionTab[index] === 'en'" class="groups_input" placeholder="description" style="margin-right: 15px;width: 100%"></el-input>
                        <YTI18NTabs v-model="activityDescriptionTab[index]"></YTI18NTabs>
                      </div>
                    </div>
                  </el-form-item>
                </div>
                <el-divider/>
                <div class="flex_left">
                  <el-form-item label="骑行距离：">
                    <div class="father_box">
                      <el-popconfirm
                          width="288"
                          :title="`活动已增加组别并填写对应骑行距离，此项无需填写`"
                      >
                        <template #reference>
                          <div class="flex_left mg_r_3 cursor-pointer">
                            <div style="margin-right: 13px">
                              <YTInputDisabledCover :show="ruleForm.activityInfo.activityDivisions.length > 0"></YTInputDisabledCover>
                            </div>
                          </div>
                        </template>
                        <template #actions="{ confirm, cancel }">
                          <div class="flex_right">
                            <v-btn size="small" color="#796CB4" @click="cancel">知道了！</v-btn>
                          </div>
                        </template>
                      </el-popconfirm>
                      <el-input-number :disabled="ruleForm.activityInfo.activityDivisions.length > 0" class="cycling_box" style="margin-right: 53px;width: 160px;" :precision="2" :min="0" v-model="ruleForm.activityInfo.cyclingDistance" :class=" ruleForm.activityInfo.cyclingDistance === null ? 'input-null' : 'input-filled'" placeholder="骑行距离">
                        <template #suffix>
                          <div
                              style="
                            width: 38px;
                            box-sizing: border-box;
                            padding-right: 20px;
                          "
                          >
                            km
                          </div>
                        </template>
                      </el-input-number>
                    </div>
                  </el-form-item>
                  <el-form-item label="骑行速度：">
                    <div class="father_box">
                      <el-popconfirm
                          width="288"
                          :title="`活动已增加组别并填写对应骑行速度，此项无需填写`"
                      >
                        <template #reference>
                          <div class="flex_left mg_r_3 cursor-pointer">
                            <div style="margin-right: 13px">
                              <YTInputDisabledCover :width="170" :show="ruleForm.activityInfo.activityDivisions.length > 0"></YTInputDisabledCover>
                            </div>
                          </div>
                        </template>
                        <template #actions="{ confirm, cancel }">
                          <div class="flex_right">
                            <v-btn size="small" color="#796CB4" @click="cancel">知道了！</v-btn>
                          </div>
                        </template>
                      </el-popconfirm>
                      <el-input-number :disabled="ruleForm.activityInfo.activityDivisions.length > 0" class="cycling_box" style="width: 170px;" :min="0" :precision="2" v-model="ruleForm.activityInfo.cyclingSpeed" :class=" ruleForm.activityInfo.cyclingSpeed === null ? 'input-null' : 'input-filled'" placeholder="骑行速度">
                        <template #suffix>
                          <div
                              style="
                            width: 50px;
                            box-sizing: border-box;
                            padding-right: 20px;
                          "
                          >
                            km/h
                          </div>
                        </template>
                      </el-input-number>
                    </div>
                  </el-form-item>
                </div>
                <el-form-item
                  label="输入活动相关的介绍描述："
                  label-position="top"
                  prop="description"
                >
                  <div>
                    <YTI18NTabs v-model="descriptionTab"></YTI18NTabs>
                    <div v-show="descriptionTab === 'zh'" style="margin: 15px 0">
                      <YTEditor
                          :ali-oss-path="'GOODS_DETAIL_PATH'"
                          ref="YTEditorRef"
                          :max-pic-size="3"
                          :title="'商品描述（中文）'"
                          :maxLength="2000"
                          :reviewTxt="ruleForm.description"
                          @change="handleYTEditorChange"
                      ></YTEditor>
                    </div>
                    <div v-show="descriptionTab === 'en'" style="margin: 15px 0">
                      <YTEditor
                          :ali-oss-path="'GOODS_DETAIL_PATH'"
                          ref="YTEditorEnRef"
                          :max-pic-size="3"
                          :title="'商品描述（English）'"
                          :maxLength="6000"
                          :reviewTxt="ruleForm.descriptionEn"
                          @change="handleYTEditorChange"
                      ></YTEditor>
                    </div>
                  </div>
                </el-form-item>
                <el-form-item label="活动时间：" prop="activityTime">
                  <div class="flex" style="width: 100%; padding-right: 20px">
                    <el-date-picker
                      :class="
                        ruleForm.startTime === null || ruleForm.startTime === ''
                          ? 'input-null mg_r_2'
                          : 'input-filled mg_r_2'
                      "
                      v-model="ruleForm.startTime"
                      type="datetime"
                      placeholder="选择开始日期与时间"
                      format="YYYY-MM-DD HH:mm:ss"
                      @change="
                        (val) => handleStartTimeChange(val, ruleForm.endTime)
                      "
                      :teleported="false"
                    />
                    <el-date-picker
                      :class="
                        ruleForm.endTime === null || ruleForm.endTime === ''
                          ? 'input-null'
                          : 'input-filled'
                      "
                      v-model="ruleForm.endTime"
                      type="datetime"
                      placeholder="选择结束日期与时间"
                      format="YYYY-MM-DD HH:mm:ss"
                      :disabled-date="
                        (time) => disabledEndDate(time, ruleForm.startTime)
                      "
                      :teleported="false"
                    />
                  </div>
                </el-form-item>
              </template>
            </YTCard>
            <YTCard :title="`报名信息`" id="signup">
              <template #container>
                <el-form-item label="报名时间：" prop="applyTime">
                  <div class="flex" style="width: 100%; padding-right: 20px">
                    <el-date-picker
                      :class="
                        ruleForm.applyStartTime === null ||
                        ruleForm.applyStartTime === ''
                          ? 'input-null mg_r_2'
                          : 'input-filled mg_r_2'
                      "
                      v-model="ruleForm.applyStartTime"
                      type="datetime"
                      placeholder="选择开始日期与时间"
                      format="YYYY-MM-DD HH:mm:ss"
                      @change="
                        (val) =>
                          handleStartTimeChange(val, ruleForm.applyEndTime)
                      "
                      :disabled-date="
                        (time) =>
                          disabledApplyStartTime(time, ruleForm.startTime)
                      "
                      :teleported="false"
                    />
                    <el-date-picker
                      :class="
                        ruleForm.applyEndTime === null ||
                        ruleForm.applyEndTime === ''
                          ? 'input-null'
                          : 'input-filled'
                      "
                      v-model="ruleForm.applyEndTime"
                      type="datetime"
                      placeholder="选择结束日期与时间"
                      format="YYYY-MM-DD HH:mm:ss"
                      :disabled-date="
                        (time) => disabledEndDate(time, ruleForm.applyStartTime)
                      "
                      :teleported="false"
                    />
                  </div>
                </el-form-item>
                <el-form-item label="人数上限：" prop="inventory" style="margin-bottom: 20px;">
                  <div class="father_box flex">
                    <el-popconfirm
                        width="288"
                        :title="`活动已增加组别并填写对应人数上限，此项无需填写`"
                    >
                      <template #reference>
                        <div class="flex_left cursor-pointer">
                          <YTInputDisabledCover :top="-2" :left="-1" :width="182" :height="44" :show="ruleForm.activityInfo.activityDivisions.length > 0"></YTInputDisabledCover>
                        </div>
                      </template>
                      <template #actions="{ confirm, cancel }">
                        <div class="flex_right">
                          <v-btn size="small" color="#796CB4" @click="cancel">知道了！</v-btn>
                        </div>
                      </template>
                    </el-popconfirm>
                    <el-input-number
                        :min="1"
                        :max="100000"
                        :precision="0"
                        v-model="ruleForm.inventory.totalQty"
                        :class="
                      ruleForm.inventory.totalQty === null ||
                      ruleForm.inventory.totalQty === 0
                        ? 'input-null'
                        : 'input-filled'
                    "
                        style="width: 180px; height: 36px"
                        :disabled="ruleForm.activityInfo.activityDivisions.length > 0"
                        placeholder="人数上限"
                        v-if="ruleForm.activityInfo.activityDivisions.length === 0"
                    ></el-input-number>
                    <div
                        style="
                      font-weight: 500;
                      font-size: 18px;
                      color: #272539;
                      margin-left: 15px;
                    "
                    >
                      人
                    </div>
                  </div>
                </el-form-item>
                <div class="flex tips" style="margin-bottom: 37px;">
                  <img
                      style="width: 18px; height: 18px; margin-right: 10px"
                      src="https://yttec-bucket.oss-cn-guangzhou.aliyuncs.com/resources/newUi/common/common/tips.svg"
                  />
                  <div>
                    人数最高可填10万人
                  </div>
                </div>
                <el-form-item label="证件信息：">
                  <div class="flex_left">
                    <div style="margin-right: 13px">
                      <YTRadio
                        :show="ruleForm.activityInfo.requireIdInfo"
                        @click="
                          ruleForm.activityInfo.requireIdInfo =
                            !ruleForm.activityInfo.requireIdInfo
                        "
                      ></YTRadio>
                    </div>
                    <div style="font-size: 16px" class="tips">
                      需要，会员报名时需要填写身份证或港澳通行证等相关证件资料
                    </div>
                  </div>
                </el-form-item>
                <el-form-item label="收货信息：">
                  <div class="flex_left">
                    <div class="flex_center mg_r_2" @click="handleChangeShippingInfoRequired('REQUIRED')">
                      <div style="margin-right: 13px">
                        <YTRadio
                            :show="ruleForm.activityInfo.shippingInfoRequired === 'REQUIRED'"
                        ></YTRadio>
                      </div>
                      <div style="font-size: 16px" class="tips">
                        需要，且为必填内容
                      </div>
                    </div>
                    <div class="flex_center" @click="handleChangeShippingInfoRequired('OPTIONAL')">
                      <div style="margin-right: 13px">
                        <YTRadio
                            :show="ruleForm.activityInfo.shippingInfoRequired === 'OPTIONAL'"
                        ></YTRadio>
                      </div>
                      <div style="font-size: 16px" class="tips">
                        需要，为非必填内容
                      </div>
                    </div>
                  </div>
                </el-form-item>
                <el-form-item label="新媒体平台信息" prop="mediaPlatformRequired" v-if="ruleForm.activityInfo.activityType === 'ONLINE'">
                  <div class="flex_left mg_r_3 cursor-pointer" @click="handleChangeMediaPlatformRequired('REQUIRED')">
                    <div style="margin-right: 13px">
                      <YTRadio
                          :show="ruleForm.activityInfo.mediaPlatformRequired === 'REQUIRED'"
                      ></YTRadio>
                    </div>
                    <div style="font-size: 16px" class="tips">
                      需要，且为必填内容
                    </div>
                  </div>
                  <div class="flex_left mg_r_3 cursor-pointer" @click="handleChangeMediaPlatformRequired('OPTIONAL')">
                    <div style="margin-right: 13px">
                      <YTRadio
                          :show="ruleForm.activityInfo.mediaPlatformRequired === 'OPTIONAL'"
                      ></YTRadio>
                    </div>
                    <div style="font-size: 16px" class="tips">
                      需要，非必填内容
                    </div>
                  </div>
                </el-form-item>
                <el-form-item label="报名范围：" prop="visibilityType">
                  <div class="flex_bt" v-if="!isEdit">
                    <div v-if="ruleForm.activityInfo.visibilityType !== 'PUBLIC'">
                      <el-popconfirm
                          width="288"
                          @confirm="handleVisibilityChange('PUBLIC')"
                          :title="`报名范围设置为“全平台公开”吗？活动发布后，将无法再次修改`"
                      >
                        <template #reference>
                          <div class="flex_left mg_r_3 cursor-pointer">
                            <div style="margin-right: 13px">
                              <YTRadio
                                  :show="ruleForm.activityInfo.visibilityType === 'PUBLIC'"
                              ></YTRadio>
                            </div>
                            <div style="font-size: 16px" class="tips">
                              全平台公开
                            </div>
                          </div>
                        </template>
                        <template #actions="{ confirm, cancel }">
                          <div class="flex_right">
                            <v-btn class="mg_r_2" size="small" @click="cancel">取消</v-btn>
                            <v-btn size="small" color="#796CB4" @click="confirm"
                            >确定</v-btn
                            >
                          </div>
                        </template>
                      </el-popconfirm>
                    </div>
                    <div v-else>
                      <div class="flex_left mg_r_3 cursor-pointer" @click="handleVisibilityChange('PUBLIC')">
                        <div style="margin-right: 13px">
                          <YTRadio
                              :show="ruleForm.activityInfo.visibilityType === 'PUBLIC'"
                          ></YTRadio>
                        </div>
                        <div style="font-size: 16px" class="tips">
                          全平台公开
                        </div>
                      </div>
                    </div>
                    <div v-if="ruleForm.activityInfo.visibilityType !== 'MEMBER_VISIBLE'">
                      <el-popconfirm
                          width="288"
                          @confirm="handleVisibilityChange('MEMBER_VISIBLE')"
                          :title="`报名范围设置为“仅商家自身会员可报名”吗？活动发布后，将无法再次修改`"
                      >
                        <template #reference>
                          <div class="flex_left mg_r_3 cursor-pointer">
                            <div style="margin-right: 13px">
                              <YTRadio
                                  :show="ruleForm.activityInfo.visibilityType === 'MEMBER_VISIBLE'"
                              ></YTRadio>
                            </div>
                            <div style="font-size: 16px" class="tips">
                              仅商家自身会员可报名
                            </div>
                          </div>
                        </template>
                        <template #actions="{ confirm, cancel }">
                          <div class="flex_right">
                            <v-btn class="mg_r_2" size="small" @click="cancel">取消</v-btn>
                            <v-btn size="small" color="#796CB4" @click="confirm"
                            >确定</v-btn
                            >
                          </div>
                        </template>
                      </el-popconfirm>
                    </div>
                    <div v-else>
                      <div class="flex_left mg_r_3 cursor-pointer">
                        <div style="margin-right: 13px" @click="handleVisibilityChange('MEMBER_VISIBLE')">
                          <YTRadio
                              :show="ruleForm.activityInfo.visibilityType === 'MEMBER_VISIBLE'"
                          ></YTRadio>
                        </div>
                        <div style="font-size: 16px" class="tips">
                          仅商家自身会员可报名
                        </div>
                      </div>
                    </div>
                    <div v-if="ruleForm.activityInfo.visibilityType !== 'SPECIFIED_USER'">
                      <el-popconfirm
                          width="288"
                          @confirm="handleVisibilityChange('SPECIFIED_USER')"
                          :title="`报名范围设置为“仅被邀请会员可报名”吗？活动发布后，将无法再次修改`"
                      >
                        <template #reference>
                          <div style="z-index: 10;position: relative">
                            <div :class="['flex_left', 'mg_r_3', 'cursor-pointer', {visibility_active : ruleForm.activityInfo.visibilityType === 'SPECIFIED_USER'}]">
                              <div style="margin-right: 13px">
                                <YTRadio
                                    :show="ruleForm.activityInfo.visibilityType === 'SPECIFIED_USER'"
                                ></YTRadio>
                              </div>
                              <div style="font-size: 16px" class="tips">
                                仅被邀请会员可报名
                              </div>
                              <div @click="handleInviteMemberDialog" v-if="ruleForm.activityInfo.visibilityType === 'SPECIFIED_USER'" class="visibility_active_view_box cursor-pointer">
                                查看被邀请会员
                              </div>
                            </div>
                            <div class="visibility_active_view_box_expansion" v-if="ruleForm.activityInfo.visibilityType === 'SPECIFIED_USER'"></div>
                          </div>
                        </template>
                        <template #actions="{ confirm, cancel }">
                          <div class="flex_right">
                            <v-btn class="mg_r_2" size="small" @click="cancel">取消</v-btn>
                            <v-btn size="small" color="#796CB4" @click="confirm"
                            >确定</v-btn
                            >
                          </div>
                        </template>
                      </el-popconfirm>
                    </div>
                    <div v-else>
                      <div style="z-index: 10;position: relative">
                        <div :class="['flex_left', 'mg_r_3', 'cursor-pointer', {visibility_active : ruleForm.activityInfo.visibilityType === 'SPECIFIED_USER'}]">
                          <div class="flex_left" @click="handleVisibilityChange('SPECIFIED_USER')">
                            <div style="margin-right: 13px">
                              <YTRadio
                                  :show="ruleForm.activityInfo.visibilityType === 'SPECIFIED_USER'"
                              ></YTRadio>
                            </div>
                            <div style="font-size: 16px" class="tips">
                              仅被邀请会员可报名
                            </div>
                          </div>
                          <div @click="handleInviteMemberDialog" v-if="ruleForm.activityInfo.visibilityType === 'SPECIFIED_USER'" class="visibility_active_view_box cursor-pointer">
                            查看被邀请会员
                          </div>
                        </div>
                        <div class="visibility_active_view_box_expansion" v-if="ruleForm.activityInfo.visibilityType === 'SPECIFIED_USER'"></div>
                      </div>
                    </div>
                  </div>
                  <div class="flex_bt" v-else>
                    <div class="flex_left mg_r_3 cursor-pointer" @click="handleShowVisibilityError">
                      <div style="margin-right: 13px">
                        <YTRadio
                            :show="ruleForm.activityInfo.visibilityType === 'PUBLIC'"
                        ></YTRadio>
                      </div>
                      <div style="font-size: 16px" class="tips">
                        全平台公开
                      </div>
                    </div>
                    <div class="flex_left mg_r_3 cursor-pointer" @click="handleShowVisibilityError">
                      <div style="margin-right: 13px">
                        <YTRadio
                            :show="ruleForm.activityInfo.visibilityType === 'MEMBER_VISIBLE'"
                        ></YTRadio>
                      </div>
                      <div style="font-size: 16px" class="tips">
                        仅商家自身会员可报名
                      </div>
                    </div>
                    <div style="z-index: 10;position: relative">
                      <div :class="['flex_left', 'mg_r_3', 'cursor-pointer', {visibility_active : ruleForm.activityInfo.visibilityType === 'SPECIFIED_USER'}]">
                        <div class="flex_left" @click="handleVisibilityChange('SPECIFIED_USER')">
                          <div style="margin-right: 13px">
                            <YTRadio
                                :show="ruleForm.activityInfo.visibilityType === 'SPECIFIED_USER'"
                            ></YTRadio>
                          </div>
                          <div style="font-size: 16px" class="tips">
                            仅被邀请会员可报名
                          </div>
                        </div>
                        <div @click="handleInviteMemberDialog" v-if="ruleForm.activityInfo.visibilityType === 'SPECIFIED_USER'" class="visibility_active_view_box cursor-pointer">
                          查看被邀请会员
                        </div>
                      </div>
                      <div class="visibility_active_view_box_expansion" v-if="ruleForm.activityInfo.visibilityType === 'SPECIFIED_USER'"></div>
                    </div>
                  </div>
                </el-form-item>
                <el-form-item label="活动详情可见范围：" prop="visibilityType" style="margin-bottom: 0" v-if="ruleForm.activityInfo.visibilityType === 'MEMBER_VISIBLE' || ruleForm.activityInfo.visibilityType === 'SPECIFIED_USER'">
                  <div class="flex_bt" v-if="!isEdit">
                    <div v-if="ruleForm.activityInfo.detailVisibilityType !== 'PUBLIC'">
                      <el-popconfirm
                          width="288"
                          @confirm="handleDetailVisibilityTypeChange('PUBLIC')"
                          :title="`确定报名范围设置为“全平台可见，${ruleForm.activityInfo.visibilityType === 'MEMBER_VISIBLE' ? '仅商家自身会员可报名' : '仅被邀请会员可报名'}”吗？活动发布后，将无法再次修改`"
                      >
                        <template #reference>
                          <div class="flex_left mg_r_3 cursor-pointer">
                            <div style="margin-right: 13px">
                              <YTRadio
                                  :show="ruleForm.activityInfo.detailVisibilityType === 'PUBLIC'"
                              ></YTRadio>
                            </div>
                            <div style="font-size: 16px" class="tips">
                              全平台公开
                            </div>
                          </div>
                        </template>
                        <template #actions="{ confirm, cancel }">
                          <div class="flex_right">
                            <v-btn class="mg_r_2" size="small" @click="cancel">取消</v-btn>
                            <v-btn size="small" color="#796CB4" @click="confirm"
                            >确定</v-btn
                            >
                          </div>
                        </template>
                      </el-popconfirm>
                    </div>
                    <div v-else>
                      <div class="flex_left mg_r_3 cursor-pointer">
                        <div style="margin-right: 13px">
                          <YTRadio
                              :show="ruleForm.activityInfo.detailVisibilityType === 'PUBLIC'"
                          ></YTRadio>
                        </div>
                        <div style="font-size: 16px" class="tips">
                          全平台公开
                        </div>
                      </div>
                    </div>
                    <div v-if="ruleForm.activityInfo.detailVisibilityType !== 'MEMBER_VISIBLE'">
                      <el-popconfirm
                          width="288"
                          @confirm="handleDetailVisibilityTypeChange('MEMBER_VISIBLE')"
                          :title="`报名范围设置为“仅商家自身会员可见${ruleForm.activityInfo.visibilityType === 'MEMBER_VISIBLE' ? '、可报名' : '，仅被邀请会员可报名'}”吗？活动发布后，将无法再次修改`"
                      >
                        <template #reference>
                          <div class="flex_left mg_r_3 cursor-pointer">
                            <div style="margin-right: 13px">
                              <YTRadio
                                  :show="ruleForm.activityInfo.detailVisibilityType === 'MEMBER_VISIBLE'"
                              ></YTRadio>
                            </div>
                            <div style="font-size: 16px" class="tips">
                              仅商家自身会员可见
                            </div>
                          </div>
                        </template>
                        <template #actions="{ confirm, cancel }">
                          <div class="flex_right">
                            <v-btn class="mg_r_2" size="small" @click="cancel">取消</v-btn>
                            <v-btn size="small" color="#796CB4" @click="confirm"
                            >确定</v-btn
                            >
                          </div>
                        </template>
                      </el-popconfirm>
                    </div>
                    <div v-else>
                      <div class="flex_left mg_r_3 cursor-pointer">
                        <div style="margin-right: 13px">
                          <YTRadio
                              :show="ruleForm.activityInfo.detailVisibilityType === 'MEMBER_VISIBLE'"
                          ></YTRadio>
                        </div>
                        <div style="font-size: 16px" class="tips">
                          仅商家自身会员可见
                        </div>
                      </div>
                    </div>
                    <div v-if="ruleForm.activityInfo.visibilityType === 'SPECIFIED_USER'">
                      <div v-if="ruleForm.activityInfo.detailVisibilityType !== 'SPECIFIED_USER'">
                        <el-popconfirm
                            width="288"
                            @confirm="handleDetailVisibilityTypeChange('SPECIFIED_USER')"
                            :title="`报名范围设置为“仅被邀请会员可见${ruleForm.activityInfo.visibilityType === 'MEMBER_VISIBLE' ? '，仅商家自身会员可见': '、可报名'}”吗？活动发布后，将无法再次修改`"
                        >
                          <template #reference>
                            <div class="flex_left mg_r_3 cursor-pointer">
                              <div style="margin-right: 13px">
                                <YTRadio
                                    :show="ruleForm.activityInfo.detailVisibilityType === 'SPECIFIED_USER'"
                                ></YTRadio>
                              </div>
                              <div style="font-size: 16px" class="tips">
                                仅被邀请会员可见
                              </div>
                            </div>
                          </template>
                          <template #actions="{ confirm, cancel }">
                            <div class="flex_right">
                              <v-btn class="mg_r_2" size="small" @click="cancel">取消</v-btn>
                              <v-btn size="small" color="#796CB4" @click="confirm"
                              >确定</v-btn
                              >
                            </div>
                          </template>
                        </el-popconfirm>
                      </div>
                      <div v-else>
                        <div class="flex_left mg_r_3 cursor-pointer">
                          <div style="margin-right: 13px">
                            <YTRadio
                                :show="ruleForm.activityInfo.detailVisibilityType === 'SPECIFIED_USER'"
                            ></YTRadio>
                          </div>
                          <div style="font-size: 16px" class="tips">
                            仅被邀请会员可见
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="flex_bt" v-else>
                    <div class="flex_left mg_r_3 cursor-pointer" @click="handleDetailVisibilityTypeChange('PUBLIC')">
                      <div style="margin-right: 13px">
                        <YTRadio
                            :show="ruleForm.activityInfo.detailVisibilityType === 'PUBLIC'"
                        ></YTRadio>
                      </div>
                      <div style="font-size: 16px" class="tips">
                        全平台公开
                      </div>
                    </div>
                    <div class="flex_left mg_r_3 cursor-pointer" @click="handleDetailVisibilityTypeChange('MEMBER_VISIBLE')">
                      <div style="margin-right: 13px">
                        <YTRadio
                            :show="ruleForm.activityInfo.detailVisibilityType === 'MEMBER_VISIBLE'"
                        ></YTRadio>
                      </div>
                      <div style="font-size: 16px" class="tips">
                        仅商家自身会员可见
                      </div>
                    </div>
                    <div v-if="ruleForm.activityInfo.visibilityType === 'SPECIFIED_USER'">
                      <div class="flex_left mg_r_3 cursor-pointer" @click="handleDetailVisibilityTypeChange('SPECIFIED_USER')">
                        <div style="margin-right: 13px">
                          <YTRadio
                              :show="ruleForm.activityInfo.detailVisibilityType === 'SPECIFIED_USER'"
                          ></YTRadio>
                        </div>
                        <div style="font-size: 16px" class="tips">
                          不公开，仅被邀请会员可见
                        </div>
                      </div>
                    </div>
                  </div>
                </el-form-item>
                <div class="flex_left tips" v-if="ruleForm.activityInfo.visibilityType === 'PUBLIC' || (ruleForm.activityInfo.visibilityType && ruleForm.activityInfo.detailVisibilityType)">
                  <img
                      style="width: 18px; height: 18px; margin-right: 10px;margin-left: 15px;"
                      src="https://yttec-bucket.oss-cn-guangzhou.aliyuncs.com/resources/newUi/common/common/tips.svg"
                  />
                  <div v-if="ruleForm.activityInfo.visibilityType === 'PUBLIC'">
                    活动发布后，<span style="color: #684fa2">Biking Up 平台所有会员 </span> 均可见、报名参加
                  </div>
                  <div class="flex" v-if="ruleForm.activityInfo.visibilityType && ruleForm.activityInfo.detailVisibilityType">
                    活动发布后，
                    <div v-if="ruleForm.activityInfo.visibilityType === 'MEMBER_VISIBLE' && ruleForm.activityInfo.detailVisibilityType === 'PUBLIC'">
                      <span style="color: #684fa2">Biking Up 平台所有会员 </span>可见、<span style="color: #684fa2">仅商家自身会员 </span>可报名参加活动
                    </div>
                    <div v-if="ruleForm.activityInfo.visibilityType === 'MEMBER_VISIBLE' && ruleForm.activityInfo.detailVisibilityType === 'MEMBER_VISIBLE'">
                      <span style="color: #684fa2">仅商家自身会员 </span>均可见、可报名参加活动
                    </div>
                    <div v-if="ruleForm.activityInfo.visibilityType === 'SPECIFIED_USER' && ruleForm.activityInfo.detailVisibilityType === 'MEMBER_VISIBLE'">
                      <span style="color: #684fa2">仅商家自身会员 </span>可见、<span style="color: #684fa2">仅被邀请会员</span>可报名参加活动
                    </div>
                    <div v-if="ruleForm.activityInfo.visibilityType === 'SPECIFIED_USER' && ruleForm.activityInfo.detailVisibilityType === 'SPECIFIED_USER'">
                      <span style="color: #684fa2">仅被邀请会员 </span>均可见、可报名参加活动
                    </div>
                    <div v-if="ruleForm.activityInfo.visibilityType === 'SPECIFIED_USER' && ruleForm.activityInfo.detailVisibilityType === 'PUBLIC'">
                      <span style="color: #684fa2">Biking Up 平台所有会员 </span>可见，<span style="color: #684fa2">仅被邀请会员 </span>可报名参加活动
                    </div>
                  </div>
                </div>
              </template>
            </YTCard>
            <YTCard :title="`相册及费用`" id="album">
              <template #container>
                <div>
                  <el-form-item label="活动相册" style="margin-bottom: 20px">
                    <div class="flex_left">
                      <div style="margin-right: 13px">
                        <YTRadio
                          :show="ruleForm.activityInfo.hasAlbum"
                          @click="ruleForm.activityInfo.hasAlbum = !ruleForm.activityInfo.hasAlbum"
                        ></YTRadio>
                      </div>
                      <div style="font-size: 16px" class="tips">创建</div>
                    </div>
                  </el-form-item>
                  <div class="flex_left tips flex_align_t">
                    <img
                      style="width: 18px; height: 18px; margin-right: 10px"
                      src="https://yttec-bucket.oss-cn-guangzhou.aliyuncs.com/resources/newUi/common/common/tips.svg"
                    />
                    <div>
                      当您选择创建活动相册并发布活动后，将
                      <span style="color: #684fa2"
                        >增加活动相关的非直播相册入口</span
                      >
                      ，会员报名后可查看相册。如下方示意图
                    </div>
                  </div>
                  <div
                    class="tips"
                    style="box-sizing: border-box; padding-left: 28px"
                  >
                    如您有任何疑问，请在周一至周五 10:00-17:00 致电 BIKING UP
                    服务热线咨询：400-8032-881
                  </div>
                  <div
                    class="tips"
                    style="
                      display: flex;
                      align-items: center;
                      margin-top: 20px;
                      padding-left: 28px;
                    "
                  >
                    <img
                      src="https://yttec-bucket.oss-cn-guangzhou.aliyuncs.com/resources/newUi/club/album1.png"
                      style="
                        width: 278px;
                        height: 123px;
                      "
                    />
                    <img
                      src="https://yttec-bucket.oss-cn-guangzhou.aliyuncs.com/resources/newUi/club/album2.png"
                      style="
                        width: 233px;
                        height: 123px;
                        margin-left: 30px;
                      "
                    />
                  </div>
                  <el-form-item
                    label="活动费用："
                    prop="retailPrice"
                    style="margin-bottom: 20px; margin-top: 37px"
                  >
                    <div class="father_box">
                      <el-popconfirm
                          width="288"
                          :title="`活动已增加组别并填写对应活动费用，此项无需填写`"
                      >
                        <template #reference>
                          <div class="flex_left cursor-pointer">
                            <YTInputDisabledCover :top="-2" :left="-1" :width="182" :height="44" :show="ruleForm.activityInfo.activityDivisions.length > 0"></YTInputDisabledCover>
                          </div>
                        </template>
                        <template #actions="{ confirm, cancel }">
                          <div class="flex_right">
                            <v-btn size="small" color="#796CB4" @click="cancel">知道了！</v-btn>
                          </div>
                        </template>
                      </el-popconfirm>
                      <el-input-number
                          class="coast_box"
                          :min="0"
                          :precision="2"
                          v-model="ruleForm.retailPrice"
                          :class="
                        ruleForm.retailPrice === null
                          ? 'input-null'
                          : 'input-filled'
                      "
                          style="width: 180px; height: 36px; text-align: left"
                          placeholder="活动费用"
                      >
                        <template #prefix>
                          <div
                              style="
                            width: 35px;
                            box-sizing: border-box;
                            padding-left: 20px;
                          "
                          >
                            ￥
                          </div>
                        </template>
                      </el-input-number>
                    </div>
                  </el-form-item>
                  <el-form-item
                      label="退费规则："
                      prop="refundSupported"
                      style="margin-bottom: 20px; margin-top: 37px"
                  >
                    <div class="flex">
                      <el-popconfirm
                          width="288"
                          @confirm="handleRefundSupportedChange(false)"
                          :title="`退费规则设置为“不可退款，报名活动后不可退”吗？活动发布后，将无法再次修改`"
                      >
                        <template #reference>
                          <div class="flex_left mg_r_3 ">
                            <div style="margin-right: 13px">
                              <YTRadio
                                  :show="ruleForm.activityInfo.refundSupported === false"
                              ></YTRadio>
                            </div>
                            <div style="font-size: 16px" class="tips">
                              不可退款，报名活动后不可退
                            </div>
                          </div>
                        </template>
                        <template #actions="{ confirm, cancel }">
                          <div class="flex_right">
                            <v-btn class="mg_r_2" size="small" @click="cancel">取消</v-btn>
                            <v-btn size="small" color="#796CB4" @click="confirm"
                            >确定</v-btn
                            >
                          </div>
                        </template>
                      </el-popconfirm>
                      <el-popconfirm
                          width="288"
                          @confirm="handleRefundSupportedChange(true)"
                          :title="`退费规则设置为“支持退款，距活动开始24小时前随时可退”吗？活动发布后，将无法再次修改`"
                      >
                        <template #reference>
                          <div class="flex_left">
                            <div style="margin-right: 13px">
                              <YTRadio
                                  :show="ruleForm.activityInfo.refundSupported === true"
                              ></YTRadio>
                            </div>
                            <div style="font-size: 16px" class="tips">
                              支持退款，距活动开始24小时前随时可退
                            </div>
                          </div>
                        </template>
                        <template #actions="{ confirm, cancel }">
                          <div class="flex_right">
                            <v-btn class="mg_r_2" size="small" @click="cancel">取消</v-btn>
                            <v-btn size="small" color="#796CB4" @click="confirm"
                            >确定</v-btn
                            >
                          </div>
                        </template>
                      </el-popconfirm>


                    </div>
                  </el-form-item>
                  <div class="flex_left tips">
                    <img
                      style="width: 18px; height: 18px; margin-right: 10px"
                      src="https://yttec-bucket.oss-cn-guangzhou.aliyuncs.com/resources/newUi/common/common/tips.svg"
                    />
                    <div>
                      活动费用由Biking Up 平台统一代收，平台将收取
                      <span style="color: #684fa2">5%</span> 手续费
                    </div>
                  </div>
                  <div
                    class="tips"
                    style="box-sizing: border-box; padding-left: 28px"
                  >
                    最终结算金额Biking
                    Up平台将在适用的结算周期内结算，具体信息请查看您签署的
                    <span style="color: #684fa2">《俱乐部合作协议》</span>。
                  </div>
                </div>
              </template>
            </YTCard>
          </div>
        </div>
        <div class="activity_form_bottom_box flex_right">
          <v-btn
            class="activity_form_bottom_btn"
            :color="`#4CAF50`"
            :disabled="submitDisabled"
            @click="handleSubmit"
            >立即发布</v-btn
          >
        </div>
      </div>
    </div>
  </el-form>
  <el-dialog
      id="dialog"
      v-model="open"
      width="990"
      style="padding: 20px"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :show-close="false">
    <template #header>
      <div class="flex_bt">
        <div class="yt_dialog_title" style="padding-bottom: 30px">报名范围(仅被邀请会员可见)</div>
        <img @click="handleDialogClose" v-if="isEdit" style="width: 24px;height: 24px;margin: 0 28px 0 0;cursor:pointer;" src="https://yttec-bucket.oss-cn-guangzhou.aliyuncs.com/resources/newUi/common/common/dialog_close.svg"/>
      </div>
    </template>
    <div class="dialog_box">
      <div class="dialog_filter_box flex_bt">
        <div class="dialog_filter_topTriangle">
          <div class="dialog_filter_topTriangle_light"></div>
        </div>
        <div class="flex_left">
          <div class="dialog_filter_txt mg_r_1">
            {{isEdit ? "被邀请会员含标签:" : "指定范围:"}}
          </div>
          <div>
            <YTTagSelect ref="YTTagSelectDialogRef" :limit="5" :selectedCount="dialogTagList.length" :width="416" :tagList="memberTagList" @tagChange="handleDialogTagChange">
              <template #trigger="{ toggle, visible }">
                <div v-if="!isEdit">
                  <div :class="['dialog_filter_select_box flex_align_t', dialogTagList.length === 0
                            ? 'input-null'
                            : 'input-filled'
                        ]">
                    <div class="flex_bt w-100">
                      <div style="flex:1;margin-right: 5px;">
                        <div class="dialog_filter_select_placeholder" v-if="dialogTagList.length === 0">请任选2-5个标签，匹配标签的所有会员将可见活动</div>
                        <div v-else class="flex flex_warp" style="gap: 5px;">
                          <div class="dialog_filter_select_tag flex_left" v-for="(item, index) in dialogTagList" :key="`tagListInput${index}`">
                            <div class="dialog_filter_select_tag_txt">{{item.tagName}}</div>
                            <div class="dialog_filter_select_tag_spaceLine"></div>
                            <div class="dialog_filter_select_tag_removeBtn" @click="handleRemoveDialogTag(item.tagId)">×</div>
                          </div>
                        </div>
                      </div>
                      <div class="dialog_filter_select_add_box flex_bt" @click="toggle" v-if="dialogTagList.length < 5">
                        <div>添加</div>
                        <img class="dialog_filter_select_add_icon" src="https://yttec-bucket.oss-cn-guangzhou.aliyuncs.com/resources/newUi/activity/activity/dialog_tag_add.svg"/>
                      </div>
                    </div>
                  </div>
                </div>
                <div v-else>
                  <div class="flex flex_warp" style="gap: 5px;">
                    <div class="dialog_filter_select_tag flex_left" style="border-radius: 5px;" v-for="(item, index) in dialogTagList" :key="`tagListInput${index}`">
                      <div class="dialog_filter_select_tag_txt">{{item.tagName}}</div>
                    </div>
                  </div>
                </div>
              </template>
            </YTTagSelect>
          </div>
        </div>
        <div class="dialog_filter_checkedCount">
          已选{{dialogMemberTotal}}名会员
        </div>
      </div>
      <div class="dialog_table_box" v-loading="dialogLoading">
        <div v-if="dialogMemberList.length > 0">
          <el-table
              :data="dialogMemberList"
              :border="false"
              style="width: 100%;"
              :header-row-style="{color: '#272539'}"
              :row-style="{color: '#656565'}"
              v-loading="loading"
              stripe
          >
            <el-table-column prop="avatar" label="会员头像" align="center">
              <template #default="scope">
                <img style="width: 34px;height: 34px;border-radius: 34px;" :src="scope.row.avatar ? scope.row.avatar : 'https://yttec-bucket.oss-cn-guangzhou.aliyuncs.com/resources/newUi/table/table/default_avatar.svg'">
              </template>
            </el-table-column>
            <el-table-column prop="nickname" label="会员昵称" width="150">
              <template #default="scope">
                <span>{{scope.row.nickname ? scope.row.nickname : "—"}}</span>
              </template>
            </el-table-column>
            <el-table-column prop="gender" label="性别">
              <template #default="scope">
                <YTGender :gender="scope.row.gender"></YTGender>
              </template>
            </el-table-column>

            <el-table-column label="会员标签" width="250" show-overflow-tooltip :tooltip-formatter="formatTags">
              <template #default="scope">
                <div>
                  <div v-if="scope.row.tagList?.length > 0" style="text-wrap: nowrap">
                    <div>{{handleShowTagList(scope.row.tagList)}}</div>
                  </div>
                  <div v-else>—</div>
                </div>
              </template>
            </el-table-column>

            <el-table-column prop="ftp" label="FTP">
              <template #default="scope">
                <span>{{scope.row.ftp ? scope.row.ftp + "W" : "—"}}</span>
              </template>
            </el-table-column>
            <el-table-column prop="carBrand" label="车辆品牌">
              <template #default="scope">
                <span>{{scope.row.carBrand ? scope.row.carBrand : "—"}}</span>
              </template>
            </el-table-column>
          </el-table>
          <div class="dialog_table_pagination_box">
            <div class="flex">
              <div :class="['dialog_table_pagination_btn', {dialog_table_pagination_btn_disabled: dialogPage <= 1}]" style="border-radius: 4px 0 0 4px;border-right: none;" @click="handleDialogPageBtnChange('reduction')">上一页</div>
              <div class="dialog_table_pagination_input_box">
                <input autocomplete="off" @input="handleDialogPageInput" @keydown.enter="handleDialogPageChange" @change="handleDialogPageChange" v-model="pageInput" name="left" class="dialog_table_pagination_input" style="text-align: right;padding-right: 2px;" />/
                <input :value="Math.ceil(dialogMemberTotal / dialogPageSize)" name="right" disabled class="dialog_table_pagination_input" style="text-align: left;padding-left: 2px" />
              </div>
              <div :class="['dialog_table_pagination_btn', {dialog_table_pagination_btn_disabled: dialogPage >= dialogMemberTotal / dialogPageSize}]" style="border-radius: 0 4px 4px 0;border-left: none;" @click="handleDialogPageBtnChange('plus')">下一页</div>
            </div>
          </div>
        </div>
        <div class="dialog_table_empty" v-else>
          <div v-show="dialogTagList.length === 0">暂无指定成员，请添加标签进行选择</div>
          <div v-show="dialogTagList.length > 0">选中的标签暂无成员，请先将成员添加标签或切换选择其他标签</div>
        </div>
      </div>
    </div>
    <template #footer>
      <div class="yt_dialog_footer">
        <v-btn v-if="!isEdit" color="#d7d7df" variant="elevated" @click="handleDialogClose">取消</v-btn>
        <v-btn v-if="!isEdit" class="mg_l_2" color="#4CAF50" variant="elevated" @click="handleDialogSubmit">确定</v-btn>
      </div>
    </template>
  </el-dialog>
  <el-dialog
      id="dialog"
      v-model="openExamples"
      width="600"
      style="padding: 20px"
      :title="'图片示例（用户浏览活动效果）'"
      :show-close="false">
    <div class="flex_center">
      <div class="mg_r_2">
        <img style="width: 200px;height: 400px;" src="https://yttec-bucket.oss-cn-guangzhou.aliyuncs.com/resources/newUi/activity/activity/cover1_examples.png"/>
        <div style="text-align: center;font-size: 16px;">封面一所在位置</div>
      </div>
      <div>
        <img style="width: 200px;height: 400px;" src="https://yttec-bucket.oss-cn-guangzhou.aliyuncs.com/resources/newUi/activity/activity/cover2_examples.png"/>
        <div style="text-align: center;font-size: 16px;">封面二所在位置</div>
      </div>
    </div>
  </el-dialog>
</template>

<style lang="scss" scoped>
.activity_upload_box {
  width: 377px;
  height: 100%;
  box-sizing: border-box;
  padding: 63px 0 0 53px;
  background: url("https://yttec-bucket.oss-cn-guangzhou.aliyuncs.com/resources/newUi/activity/activity/upload_bg.png");
  background-size: 100% 100%;
  border-radius: 15px 0 0 15px;
}
.activity_form_box {
  height: calc(100% - 220px);
  flex: 1;
  overflow-y: auto;
  margin-bottom: 35px;
}
.activity_form_bottom_box {
  box-sizing: border-box;
  padding: 0 40px 0 20px;
  .activity_form_bottom_btn {
    width: 150px;
    height: 50px;
    font-weight: 500;
    font-size: 19px;
    color: #ffffff;
  }
}

::v-deep(.el-form-item__label) {
  font-size: 18px;
}
::v-deep(.el-date-editor--datetime) {
  .el-input__wrapper {
    width: 280px;
    height: 36px;
    background: #ececf4;
    border-radius: 15px;
  }
}
::v-deep(.el-form-item) {
  margin-bottom: 37px;
}
::v-deep(.el-form-item__label) {
  display: inline-block;
  height: 44px;
  line-height: 44px;
}
::v-deep(.coast_box .el-input__inner) {
  text-align: left;
}
::v-deep(.cycling_box .el-input__inner) {
  text-align: right;
}
.tips {
  font-weight: 500;
  font-size: 14px;
  color: #6f717d;
}

.yt_tag_select_box {
  min-width: 240px;
  height: 36px;
  .yt_tag_select_suffix {
    .yt_tag_select_suffix_icon {
      transition: transform 0.2s ease;
    }
    .reverse {
       transform: rotate(180deg);
     }

  }
  .yt_tag_select_placeholder {
    color: #a8abb2;
  }
  .yt_tag_select_tag {
    width: 108px;
    background: #F4F4F5;
    border-radius: 6px;
    box-sizing: border-box;
    padding: 4px 10px;
    font-weight: 400;
    font-size: 13px;
    color: #989BA1;
    margin-right: 5px;
  }
  .yt_tag_select_tag:last-child {
    margin-right: 0;
  }
}

.visibility_active {
  background: #F1EFF9;
  border-radius: 15px;
  border: 1px solid #7A6DB4;
  box-sizing: border-box;
  padding: 6px 8px;
  position: relative;
  z-index: 9;
}
.visibility_active_view_box {
  position: absolute;
  top: 0;
  right: 0;
  height: 25px;
  line-height: 25px;
  background: #7A6DB4;
  border-radius: 9px;
  transform: translate(0%, -25px);
  font-weight: 400;
  font-size: 13px;
  color: #FFFFFF;
  box-sizing: border-box;
  padding: 1px 10px;
  user-select: none;
}
.visibility_active_view_box_expansion {
  position: absolute;
  top: -5px;
  right: 31px;
  width: 50px;
  height: 25px;
  background: #7A6DB4;
  z-index: 8;
}
.dialog_box {
  box-sizing: border-box;
  padding: 0 33px;
  .dialog_filter_box {
    width: 100%;
    min-height: 64px;
    background: #F5F6F7;
    border-radius: 15px 15px 0 0;
    border: 1px solid #DADDE2;
    box-sizing: border-box;
    padding: 8px 35px;
    position: relative;
    .dialog_filter_topTriangle {
      width: 14px;
      height: 7px;
      background: #DADDE2;
      clip-path: polygon(50% 0%, 0% 100%, 100% 100%);
      position: absolute;
      top: -7px;
      left: 40px;
      .dialog_filter_topTriangle_light {
        width: 12px;
        height: 6px;
        background: #F5F6F7;
        clip-path: polygon(50% 0%, 0% 100%, 100% 100%);
        position: absolute;
        bottom: -0.3px;
        left: 1px;
      }
    }
    .dialog_filter_txt {
      font-weight: 500;
      font-size: 18px;
      color: #6F717D;
    }
    .dialog_filter_checkedCount {
      font-weight: 500;
      font-size: 16px;
      color: #18263C;
    }
    .dialog_filter_select_box {
      width: 465px;
      min-height: 42px;
      background: #FFFFFF;
      border-radius: 21px;
      border: 1px solid #DADDE2;
      box-sizing: border-box;
      padding: 11px 7px 11px 17px;
      .dialog_filter_select_placeholder {
        font-weight: 400;
        font-size: 16px;
        color: #9C9EAB;
        user-select: none;
      }
      .dialog_filter_select_add_box {
        width: 104px;
        height: 30px;
        background: #ECECF4;
        border-radius: 15px;
        box-sizing: border-box;
        padding: 0 24px;
        font-weight: 400;
        font-size: 16px;
        color: #6F717D;
        cursor: pointer;
      }
      .dialog_filter_select_add_icon {
        width: 17px;
        height: 17px;
      }
    }
    .dialog_filter_select_box:hover {
      box-shadow: 0 0 0 1px #272539;
    }
    .dialog_filter_select_tag {
      height: 25px;
      background: #F1EBFF;
      border-radius: 15px;
      border: 1px solid #DECEFF;
      box-sizing: border-box;
      padding: 5px 7px;
      color: #B292F1;
      .dialog_filter_select_tag_txt {
        font-weight: 500;
        font-size: 11px;
        line-height: 20px;
        text-wrap: nowrap;
      }
      .dialog_filter_select_tag_spaceLine {
        width: 1px;
        height: 13px;
        background-color: #B292F1;
        margin: 0 3px;
      }
      .dialog_filter_select_tag_removeBtn {
        font-size: 16px;
        cursor: pointer;
      }
    }
    .dialog_filter_select_tag:last-child {
      margin-right: 0;
    }
  }
  .dialog_table_box {
    width: 100%;
    min-height: 515px;
    background: #FFFFFF;
    border-radius: 0 0 15px 15px;
    border: 1px solid #DADDE2;
    border-top: none;
    position: relative;
    padding-bottom: 64px;
    .dialog_table_empty {
      width: 100%;
      height: 515px;
      font-weight: 500;
      font-size: 22px;
      color: #BBBABA;
      display: flex;
      justify-content: center;
      align-items: center;
    }
    ::v-deep(.el-table__header-wrapper) {
      display: none;
    }
    .dialog_table_pagination_box {
      width: 100%;
      height: 64px;
      background: #F5F6F7;
      border-radius: 0 0 15px 15px;
      position: absolute;
      bottom: 0;
      left: 0;
      box-sizing: border-box;
      padding: 0 36px;
      display: flex;
      justify-content: flex-end;
      align-items: center;
      .dialog_table_pagination_btn {
        background: #FFFFFF;
        border: 1px solid #DADDE2;
        box-sizing: border-box;
        padding: 0 10px;
        font-weight: 400;
        font-size: 14px;
        color: #828D98;
        line-height: 29px;
        cursor: pointer;
        user-select: none;
      }
      .dialog_table_pagination_btn_disabled {
        cursor: not-allowed!important;
        color: #9C9EAB!important;
      }
      .dialog_table_pagination_input_box {
        min-width: 92px;
        height: 31px;
        background: #FFFFFF;
        border: 1px solid #DADDE2;
        font-weight: 500;
        font-size: 14px;
        color: #828D98;
        .dialog_table_pagination_input {
          width: 65px;
          padding: 0 10px;
          line-height: 30px;
          font-weight: 500;
          font-size: 14px;
          color: #828D98;
          outline: none;
        }
        .dialog_table_pagination_input:focus {
          color: #000!important;
        }
      }
    }
  }
}
.add_btn_txt {
  color: #684FA2;
  font-size: 14px;
}
.add_btn_txt_tips {
  color: #6F717D;
  font-size: 14px;
}
.groups_info {
  width: 100%;
  font-family: OPPOSans;
  font-weight: 500;
  .groups_info_title {
    color: #272539;
    font-size: 18px;
  }
  .groups_input {
    height: 44px;
    background: #FFFFFF;
    font-size: 16px;
    color: #000000;
    ::v-deep(.el-input__wrapper) {
      height: 44px;
      box-sizing: border-box;
      border-radius: 0;
    }
  }
  ::v-deep(.el-input-number) {
    border-radius: 0;
    .el-input__wrapper {
      height: 44px;
      border-radius: 0;
      font-size: 16px;

      font-weight: 500;
      color: #000000;
    }
    .el-input-number__decrease,.el-input-number__increase {
      border-radius: 0;
      width: 40px;
      height: 42px;
    }
    .el-input__inner {
      text-align: left;
    }
  }
  .groups_info_suffix {
    ::v-deep(.el-input-number) {
      .el-input__inner {
        text-align: right;
      }
    }
  }
}


</style>

